// Auto-collected interface strings, translated once per language.

export const enAuto = {
  "auto.try-again-d876": "Try Again",
  "auto.this-story-couldn-t-be-loaded-in-full-he-2027": "This story couldn't be loaded in full here. You can read it at the original source.",
  "auto.press-release-5027": "Press Release",
  "auto.back-0557": "Back",
  "auto.practice-completed-lessons-to-restore-yo-9210": "Practice completed lessons to restore your hearts!",
  "auto.practice-now-8cfb": "Practice Now",
  "auto.back-to-podcast-b4fe": "Back to Podcast",
  "auto.related-news-1e3a": "Related news",
  "auto.back-to-games-e1a4": "Back to Games",
  "auto.performance-over-time-00a3": "Performance Over Time",
  "auto.investment-thesis-d260": "Investment Thesis",
  "auto.live-f35d": "LIVE",
  "auto.ai-powered-polymarket-prediction-trackin-5a1d": "AI-powered Polymarket prediction tracking",
  "auto.refresh-63a6": "Refresh",
  "auto.active-markets-6ab2": "Active Markets",
  "auto.ai-predictions-2a62": "AI Predictions",
  "auto.top-pick-742c": "Top Pick",
  "auto.no-consensus-picks-available-yet-run-ai-6b0c": "No consensus picks available yet. Run AI analysis to generate predictions.",
  "auto.advanced-search-cd4e": "Advanced Search",
  "auto.website-15bb": "Website",
  "auto.no-episodes-available-yet-794e": "No episodes available yet",
  "auto.back-to-markets-51bb": "Back to Markets",
  "auto.trade-on-polymarket-c80a": "Trade on Polymarket",
  "auto.you-need-to-be-signed-in-to-view-your-pr-3611": "You need to be signed in to view your profile and share your thoughts.",
  "auto.the-token-you-re-looking-for-doesn-t-exi-2418": "The token you're looking for doesn't exist or has been removed.",
  "auto.whitepaper-bb56": "Whitepaper",
  "auto.github-d3b7": "GitHub",
  "auto.you-need-to-be-logged-in-to-bookmark-art-a40d": "You need to be logged in to bookmark articles and view your saved content.",
  "auto.you-haven-t-bookmarked-any-articles-yet-0cef": "You haven't bookmarked any articles yet. Start reading and bookmark the ones you like.",
  "auto.sign-in-to-see-your-activity-feed-includ-752b": "Sign in to see your activity feed, including your posts, comments, and more.",
  "auto.create-a-new-room-or-join-an-existing-on-6fde": "Create a new room or join an existing one",
  "auto.create-a-new-room-and-invite-your-friend-9557": "Create a new room and invite your friends to join using the room code.",
  "auto.please-sign-in-to-create-a-room-0398": "Please sign in to create a room",
  "auto.enter-the-6-character-room-code-shared-b-b044": "Enter the 6-character room code shared by your friend.",
  "auto.join-a286": "Join",
  "auto.please-sign-in-to-join-a-room-cc52": "Please sign in to join a room",
  "auto.start-a-room-or-join-with-a-code-fde0": "Start a room or join with a code",
  "auto.share-the-code-with-friends-dea4": "Share the code with friends",
  "auto.be-first-to-reach-the-finish-d35c": "Be first to reach the finish",
  "auto.play-de3c": "Play",
  "auto.get-started-e0c4": "Get Started",
  "auto.every-forecast-is-tracked-and-verified-s-df73": "Every forecast is tracked and verified. See real accuracy scores, not just claims.",
  "auto.no-gambling-analysts-are-paid-for-resear-096d": "No gambling. Analysts are paid for research quality, not prediction bets.",
  "auto.get-ai-powered-insights-from-news-and-po-c1f4": "Get AI-powered insights from news and podcasts when creating forecasts.",
  "auto.be-the-first-to-create-an-analyst-profil-39d9": "Be the first to create an analyst profile!",
  "auto.be-the-first-to-join-the-intelligence-pr-e035": "Be the first to join the Intelligence Pro community",
  "auto.you-already-have-an-analyst-profile-visi-2934": "You already have an analyst profile. Visit your dashboard to manage your forecasts and posts.",
  "auto.view-profile-ccd9": "View Profile",
  "auto.verify-that-you-meet-the-requirements-to-c3d5": "Verify that you meet the requirements to become an analyst",
  "auto.subscribe-to-intelligence-pro-4161": "Subscribe to Intelligence Pro",
  "auto.continue-a0bf": "Continue",
  "auto.set-up-your-analyst-identity-3e9c": "Set up your analyst identity",
  "auto.help-others-understand-your-expertise-819a": "Help others understand your expertise",
  "auto.review-your-profile-before-submitting-0b1a": "Review your profile before submitting",
  "auto.i-agree-to-the-terms-of-service-and-unde-ab09": "I agree to the terms of service and understand that my forecasts will be publicly tracked for accuracy",
  "auto.secure-payments-d4df": "Secure Payments",
  "auto.achievements-f5c7": "Achievements",
  "auto.sync-d8e8": "Sync",
  "auto.ending-soon-19b1": "Ending Soon",
  "auto.newest-ac71": "Newest",
  "auto.retry-6327": "Retry",
  "auto.nothing-tracked-yet-use-the-star-icon-on-723c": "Nothing tracked yet, use the star icon on any event.",
  "auto.cross-venue-analysis-and-market-research-18fe": "Cross-venue analysis and market research on demand. Ask anything about active markets.",
  "auto.open-copilot-d576": "Open Copilot",
  "auto.update-your-payment-method-or-cancel-any-7f97": "Update your payment method or cancel any time.",
  "auto.secure-checkout-by-stripe-cancel-any-tim-0265": "Secure checkout by Stripe. Cancel any time.",
  "auto.try-again-f915": "Try again",
  "auto.previous-dd1f": "Previous",
  "auto.next-10ac": "Next",
  "auto.loading-articles-cache-dc6d": "Loading articles cache...",
  "auto.posts-from-the-creators-we-follow-will-a-c4e8": "Posts from the creators we follow will appear here as soon as they are collected.",
  "auto.read-the-guide-ef42": "Read the guide",
  "auto.let-ai-assistants-work-directly-with-byt-7497": "Let AI assistants work directly with Byteline stories, daily recaps, weekly briefs and market data.",
  "auto.ai-article-analysis-d396": "AI Article Analysis",
  "auto.related-prediction-markets-0177": "Related Prediction Markets",
  "auto.ai-analysis-8fd8": "AI Analysis",
  "auto.generating-ai-powered-analysis-56c6": "Generating AI-powered analysis...",
  "auto.add-a-message-optional-1896": "Add a message (optional)",
  "auto.share-with-f27e": "Share with",
  "auto.forgot-password-8458": "Forgot password?",
  "auto.password-must-be-at-least-8-characters-l-db06": "Password must be at least 8 characters long",
  "auto.terms-of-service-3b6c": "Terms of Service",
  "auto.privacy-policy-fa2e": "Privacy Policy",
  "auto.this-page-is-available-to-byteline-membe-6f22": "This page is available to Byteline members.",
  "auto.sign-in-or-create-an-account-7b9d": "Sign in or create an account",
  "auto.profile-cce9": "Profile",
  "auto.bookmarks-7a69": "Bookmarks",
  "auto.your-comment-on-this-story-514b": "Your comment on this story",
  "auto.get-ai-analysis-1f35": "Get AI Analysis",
  "auto.no-chart-data-available-8de1": "No chart data available",
  "auto.daily-audio-recap-e3f1": "Daily Audio Recap",
  "auto.your-browser-does-not-support-the-audio-cd02": "Your browser does not support the audio element.",
  "auto.daily-tech-recap-f2ce": "Daily Tech Recap",
  "auto.today-s-tech-news-d448": "Today's Tech News",
  "auto.top-movers-today-34ee": "Top Movers Today",
  "auto.auto-play-next-recap-291d": "Auto-play next recap",
  "auto.unable-to-load-market-data-9492": "Unable to load market data",
  "auto.when-people-share-articles-with-you-they-a0de": "When people share articles with you, they'll appear here",
  "auto.what-s-happening-ee6c": "What's Happening",
  "auto.who-to-follow-ef20": "Who to follow",
  "auto.follow-3903": "Follow",
  "auto.leave-game-063e": "Leave Game",
  "auto.battle-royale-last-one-standing-wins-7811": "Battle Royale - Last one standing wins!",
  "auto.invite-players-4736": "Invite Players",
  "auto.start-game-1b07": "Start Game",
  "auto.waiting-for-host-to-start-2034": "Waiting for host to start...",
  "auto.go-back-4f2f": "Go Back",
  "auto.no-articles-found-the-sync-process-is-ru-96a0": "No articles found. The sync process is running in the background to fetch the latest news.",
  "auto.no-articles-match-your-current-filters-t-d861": "No articles match your current filters. Try adjusting your search or filter criteria.",
  "auto.we-aggregate-reporting-from-leading-tech-a89f": "We aggregate reporting from leading technology, business and finance publications for comprehensive coverage.",
  "auto.market-trends-b918": "Market Trends",
  "auto.view-all-tokens-d773": "View all tokens",
  "auto.long-8394": "Long",
  "auto.short-30bb": "Short",
  "auto.no-performance-data-available-yet-a345": "No performance data available yet",
  "auto.most-popular-425e": "Most Popular",
  "auto.trending-forecasts-5f36": "Trending forecasts",
  "auto.no-trending-forecasts-yet-5935": "No trending forecasts yet",
  "auto.edit-7dce": "Edit",
  "auto.preview-31fd": "Preview",
  "auto.profile-completion-7b03": "Profile Completion",
  "auto.research-co-pilot-2eeb": "Research Co-Pilot",
  "auto.show-your-appreciation-for-great-insight-be3b": "Show your appreciation for great insights",
  "auto.navigation-8464": "Navigation",
  "auto.home-8cf0": "Home",
  "auto.news-dd1b": "News",
  "auto.tokens-f686": "Tokens",
  "auto.resources-ddcf": "Resources",
  "auto.about-8f7f": "About",
  "auto.editorial-standards-bee2": "Editorial standards",
  "auto.contact-bbaf": "Contact",
  "auto.privacy-c5f2": "Privacy",
  "auto.terms-6f1b": "Terms",
  "auto.cookies-597b": "Cookies",
  "auto.no-rankings-yet-be-the-first-1539": "No rankings yet, be the first.",
  "auto.no-players-match-your-search-b9a7": "No players match your search.",
  "auto.sign-in-to-track-your-rank-streak-and-ti-982a": "Sign in to track your rank, streak, and tier progress.",
  "auto.earn-your-first-xp-to-appear-on-the-lead-136e": "Earn your first XP to appear on the leaderboard. Read an article or complete a lesson to get started.",
  "auto.jump-here-bf88": "JUMP HERE?",
  "auto.learning-achievements-2068": "Learning Achievements",
  "auto.track-your-learning-progress-and-unlock-7404": "Track your learning progress and unlock achievements",
  "auto.lessons-completed-6fe3": "Lessons Completed",
  "auto.learning-streak-bfb0": "Learning Streak",
  "auto.completion-2fea": "Completion",
  "auto.take-a-break-your-lives-will-regenerate-66b8": "Take a break! Your lives will regenerate over time, or you can practice to restore them.",
  "auto.practice-to-restore-hearts-4a1c": "Practice to Restore Hearts",
  "auto.wait-for-lives-7577": "Wait for Lives",
  "auto.complete-some-lessons-first-to-unlock-pr-5588": "Complete some lessons first to unlock practice mode!",
  "auto.review-and-earn-1-heart-291d": "Review and earn 1 heart",
  "auto.practice-8c00": "Practice",
  "auto.check-060b": "Check",
  "auto.show-more-146f": "Show more",
  "auto.load-more-articles-eb53": "Load More Articles",
  "auto.clear-all-81aa": "Clear all",
  "auto.sources-fb61": "Sources",
  "auto.reset-526d": "Reset",
  "auto.reset-all-09a5": "Reset all",
  "auto.loading-quotes-b905": "loading quotes...",
  "auto.price-trace-8313": "price trace",
  "auto.related-headlines-5c77": "related headlines",
  "auto.sell-8325": "sell",
  "auto.reset-8626": "reset",
  "auto.no-open-positions-644a": "no open positions",
  "auto.no-comments-yet-be-the-first-to-comment-7ef4": "No comments yet. Be the first to comment!",
  "auto.episode-description-d2d4": "Episode Description",
  "auto.view-episode-5504": "View Episode",
  "auto.stop-close-b6ae": "Stop & Close",
  "auto.ai-market-analysis-4df3": "AI Market Analysis",
  "auto.generate-ai-analysis-0114": "Generate AI Analysis",
  "auto.this-analysis-is-over-24-hours-old-consi-ec74": "This analysis is over 24 hours old. Consider regenerating for current data.",
  "auto.related-news-83c2": "Related News",
  "auto.from-byteline-8469": "from Byteline",
  "auto.no-related-news-found-f4e9": "No related news found",
  "auto.set-price-alert-cea7": "Set Price Alert",
  "auto.above-5b46": "Above",
  "auto.below-e59d": "Below",
  "auto.run-an-ai-analysis-combining-outcomes-oh-0fb8": "Run an AI analysis combining outcomes, OHLCV, and whale activity.",
  "auto.no-tradable-outcomes-on-this-event-yet-68d3": "No tradable outcomes on this event yet.",
  "auto.this-sends-a-real-order-with-real-money-355f": "This sends a real order with real money and cannot be undone from Byteline.",
  "auto.place-order-e796": "Place order",
  "auto.sign-in-to-connect-a-trading-account-75f2": "Sign in to connect a trading account.",
  "auto.no-whale-trades-yet-track-an-event-from-7350": "No whale trades yet, track an event from the Markets tab.",
  "auto.premium-content-fd6f": "Premium content",
  "auto.unlock-premium-cf87": "Unlock Premium",
  "auto.cancel-anytime-secure-checkout-via-strip-3655": "Cancel anytime. Secure checkout via Stripe.",
  "auto.secure-checkout-via-stripe-cancel-anytim-702b": "Secure checkout via Stripe. Cancel anytime.",
  "auto.you-will-be-redirected-to-stripe-to-comp-5491": "You will be redirected to Stripe to complete your subscription.",
  "auto.no-referrals-yet-share-your-link-to-get-af23": "No referrals yet, share your link to get started.",
  "auto.unlocked-298a": "UNLOCKED",
  "auto.no-activity-yet-start-by-creating-a-post-5295": "No activity yet. Start by creating a post or commenting on articles!",
  "auto.customize-avatar-36dd": "Customize Avatar",
  "auto.avatar-builder-b522": "Avatar Builder",
  "auto.done-f929": "Done",
  "auto.badge-unlocked-b911": "Badge Unlocked!",
  "auto.keep-up-the-amazing-work-and-unlock-more-0f90": "Keep up the amazing work and unlock more badges!",
  "auto.awesome-125a": "Awesome!",
  "auto.save-c9cc": "Save",
  "auto.download-801a": "Download",
  "auto.celebrated-c46f": "CELEBRATED",
  "auto.check-back-later-for-today-s-tech-news-r-4179": "Check back later for today's tech news roundup",
  "auto.completed-07ca": "Completed",
  "auto.earn-10-xp-90c0": "Earn 10 XP",
  "auto.following-6f79": "Following",
  "auto.you-re-not-following-anyone-yet-b2cb": "You're not following anyone yet",
  "auto.unfollow-3596": "Unfollow",
  "auto.no-followers-yet-675a": "No followers yet",
  "auto.week-1-9de8": "WEEK 1",
  "auto.view-plans-0bfd": "View Plans",
  "auto.active-4d3d": "Active",
  "auto.today-s-challenges-cbf1": "Today's Challenges",
  "auto.no-challenges-assigned-yet-check-back-to-d7e8": "No challenges assigned yet. Check back tomorrow!",
  "auto.your-monthly-badges-a889": "Your Monthly Badges",
  "auto.edit-profile-1860": "Edit Profile",
  "auto.browse-tools-0a7a": "Browse Tools",
  "auto.add-tools-81fb": "Add Tools",
  "auto.add-tokens-to-your-watchlist-to-track-th-eaca": "Add tokens to your watchlist to track their performance here.",
  "auto.add-tokens-e701": "Add Tokens",
  "auto.add-token-550f": "Add Token",
  "auto.edit-avatar-b497": "Edit Avatar",
  "auto.crypto-enthusiast-4c52": "Crypto Enthusiast",
  "auto.change-photo-80de": "Change Photo",
  "auto.browse-files-6b19": "Browse Files",
  "auto.generating-avatar-27b5": "Generating Avatar...",
  "auto.generate-avatar-c695": "Generate Avatar",
  "auto.creating-your-pixel-art-avatar-this-may-380d": "Creating your pixel art avatar... This may take 10-20 seconds.",
  "auto.generate-again-3de1": "Generate Again",
  "auto.added-f29d": "Added",
  "auto.saving-575f": "Saving...",
  "auto.your-post-262c": "Your post",
  "auto.posting-2d82": "Posting...",
  "auto.recent-searches-5c79": "Recent Searches",
  "auto.clear-dc30": "Clear",
  "auto.suggestions-41ec": "Suggestions",
  "auto.your-comment-on-this-video-0b0a": "Your comment on this video",
  "auto.sign-in-to-comment-60a6": "Sign in to comment",
  "auto.further-reading-1ba5": "Further reading",
  "auto.all-podcasts-d5fb": "All podcasts",
  "auto.weekly-performance-c408": "Weekly performance",
  "auto.market-data-was-unavailable-when-this-is-52ba": "Market data was unavailable when this issue was generated.",
  "auto.an-error-occurred-while-loading-this-pag-5668": "An error occurred while loading this page. Please try again.",
  "auto.analyzing-article-sentiment": "Analyzing article sentiment...",
  "auto.share-article-a4bd": "Share Article",
  "auto.you-re-not-following-anyone-yet-04bb": "You're not following anyone yet",
  "auto.follow-people-to-share-articles-with-the-2376": "Follow people to share articles with them",
  "auto.please-sign-in-to-join-the-discussion-5b52": "Please sign in to join the discussion",
  "auto.no-comments-yet-be-the-first-to-share-yo-849d": "No comments yet. Be the first to share your thoughts!",
  "auto.price-3e82": "Price",
  "auto.market-cap-690d": "Market cap",
  "auto.fdv-488b": "FDV",
  "auto.circulating-supply-fea1": "Circulating supply",
  "auto.ai-analysis-e639": "AI Analysis",
  "auto.markets-c3c4": "Markets",
  "auto.latest-news-4e11": "Latest News",
  "auto.no-recent-news-available-c6d3": "No recent news available",
  "auto.no-recent-news-found-3e77": "No recent news found",
  "auto.loading-chart-data-8bde": "Loading chart data...",
  "auto.searching-ba2b": "Searching...",
  "auto.name-709a": "Name",
  "auto.market-cap-d553": "Market Cap",
  "auto.actions-c3cd": "Actions",
  "auto.today-s-recap-will-be-available-soon-b12e": "Today's recap will be available soon",
  "auto.check-back-later-for-the-daily-summary-2ce9": "Check back later for the daily summary",
  "auto.no-articles-published-today-yet-e14c": "No articles published today yet",
  "auto.no-data-available-0cfc": "No data available",
  "auto.biggest-gainers-in-the-last-24-hours-b83d": "Biggest gainers in the last 24 hours",
  "auto.24h-volume-9aeb": "24h Volume",
  "auto.btc-dominance-8a7c": "BTC Dominance",
  "auto.active-cryptocurrencies-7399": "Active Cryptocurrencies",
  "auto.updated-5-min-ago-9c8f": "Updated 5 min ago",
  "auto.ai-briefing-is-unavailable-right-now-b56b": "AI briefing is unavailable right now.",
  "auto.loading-33ce": "Loading…",
  "auto.live-65c8": "Live",
  "auto.loading-live-markets-f335": "Loading live markets…",
  "auto.sort-adc4": "Sort",
  "auto.no-sources-available-yet-59f8": "No sources available yet.",
  "auto.sign-in-to-leave-a-comment-e697": "Sign in to leave a comment",
  "auto.achievements-a663": "Achievements",
  "auto.reward-c7d7": "Reward",
  "auto.your-activity-7540": "Your Activity",
  "auto.browse-web3-tools-dapps-1c3b": "Browse Web3 Tools & DApps",
  "auto.crypto-enthusiast-2e1a": "Crypto Enthusiast",
  "auto.skin-tone-6375": "Skin Tone",
  "auto.body-style-9e5b": "Body Style",
  "auto.avatar-studio-25ae": "Avatar Studio",
  "auto.character-ee99": "Character",
  "auto.body-colour-176d": "Body colour",
  "auto.cached-colours-are-free-xp-is-charged-on-3941": "Cached colours are free. XP is charged only when Nano Banana 3 creates a new colour.",
  "auto.background-64dd": "Background",
  "auto.your-collection-f01e": "Your collection",
  "auto.delete-this-avatar-fabf": "Delete this avatar?",
  "auto.cancel-77df": "Cancel",
  "auto.hair-style-fd9c": "Hair Style",
  "auto.eye-color-68a3": "Eye Color",
  "auto.accessories-f3b5": "Accessories",
  "auto.facial-hair-c8d1": "Facial Hair",
  "auto.no-recent-celebrations-a3a5": "No recent celebrations",
  "auto.commented-on-article-bf0a": "Commented on article",
  "auto.loading-recaps-5b84": "Loading recaps...",
  "auto.no-daily-recap-available-yet-13c7": "No daily recap available yet",
  "auto.daily-recap-queue-96b8": "Daily Recap Queue",
  "auto.today-s-recap-a23d": "Today's Recap",
  "auto.today-s-daily-recap-4864": "Today's Daily Recap",
  "auto.new-eee2": "New!",
  "auto.daily-recap-b0b4": "Daily Recap",
  "auto.edit-profile-cd28": "Edit Profile",
  "auto.display-name-8d6b": "Display Name",
  "auto.username-84c2": "Username",
  "auto.bio-b31f": "Bio",
  "auto.statistics-2086": "Statistics",
  "auto.no-profile-data-available-07b3": "No profile data available",
  "auto.day-streak-350f": "Day streak",
  "auto.total-xp-de22": "Total XP",
  "auto.current-league-4376": "Current league",
  "auto.your-benefits-03dd": "Your benefits:",
  "auto.view-forecasts-a04d": "View Forecasts",
  "auto.browse-analyst-predictions-7c40": "Browse analyst predictions",
  "auto.create-content-dfb9": "Create Content",
  "auto.publish-forecasts-analysis-4da4": "Publish forecasts & analysis",
  "auto.commented-on-a-podcast-episode-29be": "commented on a podcast episode",
  "auto.share-your-thoughts-af96": "Share your thoughts",
  "auto.following-90ee": "Following",
  "auto.followers-78ea": "Followers",
  "auto.edit-avatar-4ea4": "Edit avatar",
  "auto.your-stats-427c": "Your Stats",
  "auto.points-4b2a": "Points",
  "auto.day-streak-ca4b": "Day Streak",
  "auto.league-7096": "League",
  "auto.earn-points-a33f": "Earn Points",
  "auto.read-an-article-79a7": "Read an article",
  "auto.5-pts-ef93": "+5 pts",
  "auto.comment-on-article-378d": "Comment on article",
  "auto.10-pts-3247": "+10 pts",
  "auto.create-a-post-8421": "Create a post",
  "auto.15-pts-1cca": "+15 pts",
  "auto.browse-pages-eb8e": "Browse pages",
  "auto.1-pt-4a3f": "+1 pt",
  "auto.wall-c463": "Wall",
  "auto.watchlist-48a6": "Watchlist",
  "auto.tools-4fa8": "Tools",
  "auto.web3-tools-dapps-288d": "Web3 Tools & DApps",
  "auto.no-web3-tools-added-yet-a318": "No Web3 tools added yet",
  "auto.no-tokens-in-watchlist-0783": "No tokens in watchlist",
  "auto.your-watchlist-ba90": "Your Watchlist",
  "auto.ai-avatar-generator-4e96": "AI Avatar Generator",
  "auto.upload-your-photo-3a43": "Upload Your Photo",
  "auto.drop-your-photo-here-or-56ec": "Drop your photo here or",
  "auto.your-generated-avatar-177c": "Your Generated Avatar",
  "auto.filters-96e5": "Filters",
  "auto.date-range-6bb4": "Date Range",
  "auto.sources-2eb5": "Sources",
  "auto.categories-6ccb": "Categories",
  "auto.loading-suggestions-7645": "Loading suggestions...",
  "auto.this-one-cannot-be-played-here-c71c": "This one cannot be played here.",
  "auto.tap-for-sound-a80b": "Tap for sound",
  "auto.comments-fce0": "Comments",
  "auto.about-6b21": "About",
  "auto.no-comments-yet-207b": "No comments yet.",
  "auto.quick-quiz-648f": "Quick Quiz",
  "auto.editor-s-note-ffa0": "Editor's Note",
  "auto.past-issues-6510": "Past Issues",
  "auto.market-pulse-ff2f": "Market Pulse",
  "auto.crypto-e849": "Crypto",
  "auto.narrative-of-the-week-60f4": "Narrative of the Week",
  "auto.top-stories-1fa6": "Top Stories",
  "auto.listen-this-week-dda7": "Listen This Week",
  "auto.movers-7-day-5599": "Movers, 7 day",
  "auto.winners-1d50": "Winners",
  "auto.losers-6ce7": "Losers",
  "auto.what-we-publish-c716": "What we publish",
  "auto.daily-recap-of-the-stories-that-moved-th-d0dc": "Daily recap of the stories that moved the sector.",
  "auto.weekly-brief-with-the-themes-behind-the-951f": "Weekly brief with the themes behind the headlines.",
  "auto.market-pages-for-crypto-assets-and-techn-2777": "Market pages for crypto assets and technology equities.",
  "auto.topic-guides-explaining-recurring-subjec-abfd": "Topic guides explaining recurring subjects in plain language.",
  "auto.ownership-and-funding-be43": "Ownership and funding",
  "auto.contact-b374": "Contact",
  "auto.article-not-found-39d5": "Article Not Found",
  "auto.return-to-home-7d70": "Return to Home",
  "auto.admin-panel-9371": "Admin Panel",
  "auto.this-article-has-been-translated-677d": "This article has been translated",
  "auto.related-articles-cfd2": "Related Articles",
  "auto.source-6da1": "Source",
  "auto.no-recent-stories-for-this-writer-e862": "No recent stories for this writer.",
  "auto.login-to-view-bookmarks-cec4": "Login to view bookmarks",
  "auto.login-4e5a": "Login",
  "auto.no-bookmarks-yet-aaf8": "No bookmarks yet",
  "auto.browse-articles-6cc4": "Browse Articles",
  "auto.no-lessons-available-yet-f1e3": "No lessons available yet",
  "auto.need-hearts-bfc9": "Need Hearts?",
  "auto.your-progress-9839": "Your Progress",
  "auto.completion-2ff2": "Completion",
  "auto.streak-ac47": "Streak",
  "auto.sourcing-and-credit-1c70": "Sourcing and credit",
  "auto.use-of-artificial-intelligence-0101": "Use of artificial intelligence",
  "auto.verification-0312": "Verification",
  "auto.corrections-ccc7": "Corrections",
  "auto.independence-1db5": "Independence",
  "auto.episode-not-found-8ce5": "Episode not found",
  "auto.show-notes-5699": "Show Notes",
  "auto.your-feed-awaits-8973": "Your Feed Awaits",
  "auto.sign-in-f849": "Sign In",
  "auto.for-you-7e13": "For you",
  "auto.shared-with-you-72f2": "Shared with you",
  "auto.start-playing-54ff": "Start Playing",
  "auto.create-room-7a91": "Create Room",
  "auto.join-room-902f": "Join Room",
  "auto.how-to-play-9686": "How to Play",
  "auto.create-or-join-cf74": "Create or Join",
  "auto.wait-for-players-2b50": "Wait for Players",
  "auto.race-to-win-fcd6": "Race to Win!",
  "auto.game-not-found-e875": "Game not found",
  "auto.room-d295": "Room:",
  "auto.loading-game-0a6b": "Loading game...",
  "auto.games-398e": "Games",
  "auto.max-players-77c3": "Max Players",
  "auto.win-xp-ff81": "Win XP",
  "auto.subscribe-now-378b": "Subscribe Now",
  "auto.browse-forecasts-2c04": "Browse Forecasts",
  "auto.why-intelligence-pro-2b11": "Why Intelligence Pro?",
  "auto.verified-track-records-82ee": "Verified Track Records",
  "auto.halal-compliant-1ba3": "Halal-Compliant",
  "auto.ai-research-co-pilot-82f3": "AI Research Co-Pilot",
  "auto.top-analysts-4304": "Top Analysts",
  "auto.view-all-931e": "View all",
  "auto.recent-forecasts-ea5d": "Recent Forecasts",
  "auto.analyst-not-found-2f77": "Analyst not found",
  "auto.back-to-analysts-7e2c": "Back to Analysts",
  "auto.analyst-profile-502b": "Analyst Profile",
  "auto.total-forecasts-7645": "Total Forecasts",
  "auto.win-rate-49a3": "Win Rate",
  "auto.brier-score-fa35": "Brier Score",
  "auto.theses-0164": "Theses",
  "auto.playbooks-01e7": "Playbooks",
  "auto.post-mortems-75ec": "Post-Mortems",
  "auto.no-forecasts-yet-c7f3": "No forecasts yet",
  "auto.no-theses-yet-9967": "No theses yet",
  "auto.no-playbooks-yet-315b": "No playbooks yet",
  "auto.no-post-mortems-yet-0e17": "No post-mortems yet",
  "auto.active-analysts-f8dd": "Active Analysts",
  "auto.avg-accuracy-a5a5": "Avg Accuracy",
  "auto.total-followers-4db2": "Total Followers",
  "auto.no-analysts-yet-d76d": "No analysts yet",
  "auto.accuracy-12a3": "Accuracy",
  "auto.avg-brier-b28a": "Avg Brier",
  "auto.top-token-cd22": "Top Token",
  "auto.analysts-5c55": "Analysts",
  "auto.this-week-4e68": "This Week",
  "auto.accuracy-trends-efd8": "Accuracy Trends",
  "auto.prediction-types-c45b": "Prediction Types",
  "auto.token-performance-958c": "Token Performance",
  "auto.token-a114": "Token",
  "auto.forecasts-1685": "Forecasts",
  "auto.avg-confidence-0fb3": "Avg Confidence",
  "auto.checking-access-b7a3": "Checking access...",
  "auto.content-type-863e": "Content Type",
  "auto.new-forecast-25b1": "New Forecast",
  "auto.token-symbol-89a4": "Token Symbol",
  "auto.prediction-type-343a": "Prediction Type",
  "auto.price-above-548f": "Price Above",
  "auto.price-below-36c2": "Price Below",
  "auto.change-6324": "% Change",
  "auto.target-date-befd": "Target Date",
  "auto.premium-only-97e5": "Premium Only",
  "auto.title-768e": "Title",
  "auto.loading-b04b": "Loading...",
  "auto.event-not-found-0f7c": "Event not found.",
  "auto.resolved-d999": "Resolved",
  "auto.this-event-requires-ba95": "This event requires",
  "auto.tier-access-15c9": "tier access.",
  "auto.upgrade-subscription-a8c7": "Upgrade subscription",
  "auto.sign-in-to-submit-your-analysis-68fe": "Sign in to submit your analysis.",
  "auto.ai-analysis-resolution-93b9": "AI analysis & resolution",
  "auto.outcome-d3f0": "Outcome",
  "auto.ai-pre-resolution-analysis-f91e": "AI pre-resolution analysis",
  "auto.all-submissions-4ff2": "All submissions",
  "auto.forecast-not-found-28fe": "Forecast not found",
  "auto.back-to-forecasts-bd16": "Back to Forecasts",
  "auto.open-cf9b": "Open",
  "auto.correct-48e0": "Correct",
  "auto.incorrect-7831": "Incorrect",
  "auto.expired-a689": "Expired",
  "auto.forecast-detail-7798": "Forecast Detail",
  "auto.confidence-82fa": "Confidence",
  "auto.price-at-creation-b02e": "Price at Creation",
  "auto.target-price-9bf8": "Target Price",
  "auto.outcome-analysis-367b": "Outcome Analysis",
  "auto.unlock-with-pro-5bed": "Unlock with Pro",
  "auto.my-submissions-15c8": "My submissions",
  "auto.by-accuracy-d903": "By Accuracy",
  "auto.by-brier-score-9e6f": "By Brier Score",
  "auto.by-forecasts-dafd": "By Forecasts",
  "auto.by-followers-eea2": "By Followers",
  "auto.top-performers-9693": "Top Performers",
  "auto.full-rankings-2acb": "Full Rankings",
  "auto.brier-e8ca": "Brier",
  "auto.get-started-bd2c": "Get Started",
  "auto.you-re-already-an-analyst-b48e": "You're Already an Analyst!",
  "auto.check-eligibility-0fae": "Check Eligibility",
  "auto.intelligence-pro-or-elite-subscription-38e0": "Intelligence Pro or Elite Subscription",
  "auto.verified-account-0051": "Verified Account",
  "auto.your-email-is-verified-2ec3": "Your email is verified",
  "auto.create-your-profile-a092": "Create Your Profile",
  "auto.back-b52b": "Back",
  "auto.add-details-f773": "Add Details",
  "auto.specialties-1b0c": "Specialties",
  "auto.review-confirm-eabb": "Review & Confirm",
  "auto.profile-completion-e328": "Profile Completion",
  "auto.post-not-found-2a87": "Post not found",
  "auto.back-to-intelligence-ad5d": "Back to Intelligence",
  "auto.lessons-learned-e41d": "Lessons Learned",
  "auto.scenarios-2dd4": "Scenarios",
  "auto.cancel-anytime-51e2": "Cancel Anytime",
  "auto.30-day-refund-568a": "30-Day Refund",
  "auto.all-time-dbad": "All time",
  "auto.month-082b": "Month",
  "auto.week-f82b": "Week",
  "auto.market-watch-85d4": "Market Watch",
  "auto.currently-tracking-7267": "Currently tracking",
  "auto.analysis-made-61f8": "Analysis made",
  "auto.ai-consensus-b979": "AI consensus",
  "auto.no-picks-yet-1019": "No picks yet",
  "auto.top-picks-f1cb": "Top Picks",
  "auto.all-markets-8582": "All Markets",
  "auto.recent-trades-2843": "Recent Trades",
  "auto.current-price-2f9f": "Current Price",
  "auto.volume-3b18": "Volume",
  "auto.ai-analysis-1569": "AI Analysis:",
  "auto.status-bae7": "Status",
  "auto.search-for-what-you-need-7d5b": "Search for what you need",
  "auto.podcast-not-found-c941": "Podcast not found",
  "auto.prediction-markets-c6ca": "Prediction markets",
  "auto.updating-3ab0": "Updating…",
  "auto.all-events-7f14": "All Events",
  "auto.bookmarks-ca3c": "Bookmarks",
  "auto.no-active-alerts-7617": "No active alerts",
  "auto.event-not-found-231b": "Event not found",
  "auto.total-vol-7a36": "Total Vol.",
  "auto.24h-vol-d841": "24h Vol.",
  "auto.liquidity-76a3": "Liquidity",
  "auto.featured-ae31": "Featured",
  "auto.probability-chart-1fba": "Probability chart",
  "auto.outcomes-6848": "Outcomes",
  "auto.trade-b081": "Trade",
  "auto.outcome-probabilities-86db": "Outcome probabilities",
  "auto.no-markets-returned-b8e1": "No markets returned.",
  "auto.digest-47fd": "Digest",
  "auto.historical-bb2f": "Historical",
  "auto.account-85df": "Account",
  "auto.sort-volume-b0aa": "Sort: Volume",
  "auto.sort-liquidity-d93a": "Sort: Liquidity",
  "auto.sort-markets-5083": "Sort: Markets",
  "auto.sort-newest-682d": "Sort: Newest",
  "auto.your-watchlist-b916": "Your watchlist",
  "auto.sign-in-to-track-events-and-build-a-watc-50f5": "Sign in to track events and build a watchlist.",
  "auto.ai-market-copilot-3694": "AI Market Copilot",
  "auto.no-bookmarked-events-yet-0429": "No bookmarked events yet.",
  "auto.membership-53bc": "Membership",
  "auto.month-f7fa": "/ month",
  "auto.why-members-upgrade-74cc": "Why members upgrade",
  "auto.questions-9a1f": "Questions",
  "auto.billing-cancellation-and-payouts-ce6e": "Billing, cancellation and payouts.",
  "auto.couldn-t-load-press-releases-2907": "Couldn't load press releases",
  "auto.no-press-releases-yet-4851": "No press releases yet.",
  "auto.information-we-collect-ca19": "Information we collect",
  "auto.account-details-804f": "Account details.",
  "auto.things-you-create-3254": "Things you create.",
  "auto.usage-data-e2b4": "Usage data.",
  "auto.messages-you-send-us-47d6": "Messages you send us.",
  "auto.how-we-use-it-7f88": "How we use it",
  "auto.cookies-and-analytics-9285": "Cookies and analytics",
  "auto.third-party-services-871d": "Third-party services",
  "auto.keeping-and-deleting-data-8d29": "Keeping and deleting data",
  "auto.your-rights-e711": "Your rights",
  "auto.children-dcf7": "Children",
  "auto.changes-8aa5": "Changes",
  "auto.profile-not-available-d9c0": "Profile Not Available",
  "auto.nothing-here-yet-e892": "Nothing here yet",
  "auto.your-account-4ab2": "Your account",
  "auto.acceptable-use-009a": "Acceptable use",
  "auto.do-not-post-unlawful-hateful-misleading-0923": "Do not post unlawful, hateful, misleading or abusive material.",
  "auto.do-not-spam-scrape-in-bulk-or-attempt-to-977a": "Do not spam, scrape in bulk, or attempt to break or overload the site.",
  "auto.do-not-impersonate-other-people-or-misre-bd33": "Do not impersonate other people or misrepresent your affiliation.",
  "auto.do-not-upload-content-you-do-not-have-th-0818": "Do not upload content you do not have the right to share.",
  "auto.content-you-post-5d23": "Content you post",
  "auto.our-content-01c1": "Our content",
  "auto.not-financial-advice-2a1f": "Not financial advice",
  "auto.subscriptions-and-payments-e507": "Subscriptions and payments",
  "auto.third-party-material-and-links-5f0d": "Third-party material and links",
  "auto.availability-and-liability-5aca": "Availability and liability",
  "auto.token-not-found-e894": "Token not found",
  "auto.this-topic-does-not-exist-or-is-not-publ-8eb4": "This topic does not exist or is not published yet.",
  "auto.browse-all-topics-773a": "Browse all topics",
  "auto.common-questions-f07a": "Common questions",
  "auto.related-topics-25bd": "Related topics",
  "auto.supported-0bf8": "Supported",
  "auto.not-supported-in-this-browser-fb69": "Not supported in this browser",
  "auto.connect-an-outside-assistant-bb33": "Connect an outside assistant",
  "auto.add-this-address-as-an-mcp-server-in-cha-7a2a": "Add this address as an MCP server in ChatGPT, Claude, Cursor or any other MCP client.",
  "auto.writer-bbad": "Writer",
  "auto.library-4d70": "Library",
  "auto.your-bookmarks-2e4c": "Your Bookmarks",
  "auto.access-all-your-saved-articles-in-one-pl-f162": "Access all your saved articles in one place.",
  "auto.today-in-crypto-d5e1": "Today in Crypto",
  "auto.refresh-daily-data-db90": "Refresh daily data",
  "auto.social-f431": "Social",
  "auto.your-feed-a02e": "Your Feed",
  "auto.posts-comments-and-activity-from-people-fef8": "Posts, comments, and activity from people you follow.",
  "auto.search-posts-people-839f": "Search posts & people...",
  "auto.room-code-a1a2": "ROOM CODE",
  "auto.multiplayer-901a": "Multiplayer",
  "auto.games-251b": "Games",
  "auto.play-multiplayer-games-with-the-byteline-57d0": "Play multiplayer games with the Byteline community. Compete, have fun, and earn XP.",
  "auto.no-games-available-4e8d": "No games available",
  "auto.check-back-soon-for-new-games-4152": "Check back soon for new games.",
  "auto.intelligence-pro-3e16": "Intelligence Pro",
  "auto.crypto-research-social-network-496e": "Crypto Research Social Network",
  "auto.follow-top-analysts-track-their-performa-85e2": "Follow top analysts, track their performance, and access premium research. Build your reputation through verified forecast accuracy.",
  "auto.rankings-0d93": "Rankings",
  "auto.top-analysts-0d57": "Top Analysts",
  "auto.ranked-by-forecast-accuracy-and-track-re-bd75": "Ranked by forecast accuracy and track record.",
  "auto.confidence-vs-accuracy-calibration-25d4": "Confidence vs Accuracy (Calibration)",
  "auto.intelligence-8f7b": "Intelligence",
  "auto.forecast-analytics-8780": "Forecast Analytics",
  "auto.comprehensive-analytics-on-prediction-ac-0924": "Comprehensive analytics on prediction accuracy, token performance, and analyst patterns.",
  "auto.target-value-b95e": "Target Value ($)",
  "auto.investment-thesis-markdown-supported-d34a": "Investment Thesis (Markdown supported)",
  "auto.content-markdown-supported-2067": "Content (Markdown supported)",
  "auto.create-content-2e8b": "Create Content",
  "auto.publish-a-forecast-thesis-playbook-or-ot-b927": "Publish a forecast, thesis, playbook, or other analysis.",
  "auto.enter-a-compelling-title-57a5": "Enter a compelling title...",
  "auto.weekly-events-986a": "Weekly Events",
  "auto.intelligence-events-f7ab": "Intelligence Events",
  "auto.ai-curated-weekly-events-submit-your-ana-9dcf": "AI-curated weekly events. Submit your analysis. Correct analysts earn from the platform reward pool at resolution.",
  "auto.intelligence-leaderboard-94f8": "Intelligence Leaderboard",
  "auto.top-performing-analysts-ranked-by-predic-e50c": "Top performing analysts ranked by prediction accuracy, Brier score, and track record.",
  "auto.display-name-f5f9": "Display Name *",
  "auto.bio-b3eb": "Bio *",
  "auto.twitter-x-optional-9850": "Twitter/X (optional)",
  "auto.telegram-optional-5a3a": "Telegram (optional)",
  "auto.become-an-analyst-c1cc": "Become an Analyst",
  "auto.join-intelligence-pro-and-share-your-cry-fa3a": "Join Intelligence Pro and share your crypto insights with the community.",
  "auto.your-analyst-name-4ba7": "Your analyst name",
  "auto.tell-others-about-your-experience-and-ex-f227": "Tell others about your experience and expertise (min 100 characters)",
  "auto.username-94b0": "@username",
  "auto.go-back-22b6": "Go back",
  "auto.choose-your-plan-6389": "Choose Your Plan",
  "auto.unlock-premium-crypto-research-create-fo-5b58": "Unlock premium crypto research, create forecasts, and access the AI Research Co-Pilot.",
  "auto.bytelline-e3c9": "Bytelline",
  "auto.leaderboard-e02b": "Leaderboard",
  "auto.one-ranking-reading-learning-forecasting-5ec8": "One ranking. Reading, learning, forecasting, and contributions, combined.",
  "auto.active-players-2a28": "Active players",
  "auto.top-score-356a": "Top score",
  "auto.learn-2f1a": "Learn",
  "auto.web3-learning-2978": "Web3 Learning",
  "auto.choose-a-path-to-start-your-journey-into-527b": "Choose a path to start your journey into Web3 and blockchain technology.",
  "auto.no-learning-paths-yet-8f21": "No learning paths yet",
  "auto.new-courses-are-on-the-way-2f85": "New courses are on the way.",
  "auto.plus-d7d1": "plus",
  "auto.podcasts-byteline-6720": "Podcasts - Byteline",
  "auto.discover-and-listen-to-the-sharpest-show-3071": "Discover and listen to the sharpest shows on technology, markets and innovation.",
  "auto.audio-b22f": "Audio",
  "auto.podcasts-9bf7": "Podcasts",
  "auto.search-podcasts-f4ab": "Search podcasts...",
  "auto.search-podcasts-11ca": "Search podcasts",
  "auto.no-podcasts-found-39d2": "No podcasts found",
  "auto.try-a-different-search-term-7f51": "Try a different search term.",
  "auto.crypto-finance-markets-91ab": "Crypto & Finance Markets",
  "auto.track-crypto-and-finance-prediction-mark-56ea": "Track crypto and finance prediction markets.",
  "auto.sync-events-0d77": "Sync events",
  "auto.delete-alert-314c": "Delete alert",
  "auto.search-events-b514": "Search events...",
  "auto.prediction-markets-b485": "Prediction Markets",
  "auto.market-intelligence-abf2": "Market Intelligence",
  "auto.unified-view-of-global-event-markets-liv-8642": "Unified view of global event markets, live prices, volume and AI-assisted research across Kalshi and Polymarket.",
  "auto.search-events-e-g-bitcoin-fed-election-eca7": "Search events, e.g. bitcoin, fed, election…",
  "auto.you-apos-re-on-premium-03b7": "You&apos;re on Premium",
  "auto.upgrade-f683": "Upgrade",
  "auto.premium-8d5e": "Premium",
  "auto.full-text-reading-ai-briefings-and-the-c-0e22": "Full-text reading, AI briefings and the complete Byteline archive for $3 a month.",
  "auto.press-releases-byteline-3e54": "Press Releases | Byteline",
  "auto.company-announcements-partnerships-and-f-e620": "Company announcements, partnerships and funding news submitted to Byteline, published as received.",
  "auto.press-releases-01d7": "Press Releases",
  "auto.announcements-submitted-by-companies-and-ae2d": "Announcements submitted by companies and their representatives. These are not reported stories by the Byteline newsroom.",
  "auto.search-1334": "Search",
  "auto.search-articles-e8de": "Search Articles",
  "auto.search-articles-85ee": "Search articles...",
  "auto.social-byteline-f2fc": "Social - Byteline",
  "auto.creators-we-follow-on-tiktok-and-instagr-9fb9": "Creators we follow on TikTok and Instagram, covering technology, markets and innovation.",
  "auto.markets-52c3": "Markets",
  "auto.live-crypto-prices-tech-equities-top-mov-a4b1": "Live crypto prices, tech equities, top movers and your watchlist in one place.",
  "auto.search-name-or-symbol-b00d": "Search name or symbol",
  "auto.topic-not-found-byteline-3c3a": "Topic not found | Byteline",
  "auto.this-topic-does-not-exist-4f31": "This topic does not exist.",
  "auto.topic-not-found-74e6": "Topic not found",
  "auto.topics-34ac": "Topics",
  "auto.topics-byteline-d09e": "Topics | Byteline",
  "auto.guides-and-the-latest-coverage-across-ai-dec6": "Guides and the latest coverage across AI, semiconductors, robotics, space, biotech, markets, crypto and more.",
  "auto.plain-english-guides-to-the-technologies-a483": "Plain-English guides to the technologies and markets we cover, with the latest stories on each.",
  "auto.ai-connect-webmcp-8b29": "AI Connect (WebMCP)",
  "auto.weekly-brief-fc26": "Weekly Brief",
  "auto.no-brief-published-yet-d245": "No brief published yet",
  "auto.the-first-weekly-brief-will-appear-here-6718": "The first weekly brief will appear here once it's generated.",
  "auto.something-went-wrong-6609": "Something went wrong",
  "auto.skip-backward-15-seconds-4da1": "Skip backward 15 seconds",
  "auto.skip-forward-15-seconds-087f": "Skip forward 15 seconds",
  "auto.share-5a95": "Share",
  "auto.why-are-you-sharing-this-1535": "Why are you sharing this?",
  "auto.sign-in-f2fd": "Sign In",
  "auto.sign-up-d678": "Sign Up",
  "auto.email-ce8a": "Email",
  "auto.password-dc64": "Password",
  "auto.full-name-6300": "Full Name",
  "auto.you-example-com-4fca": "you@example.com",
  "auto.john-doe-4c2a": "John Doe",
  "auto.members-only-1fbc": "Members only",
  "auto.log-out-4394": "Log out",
  "auto.share-your-thoughts-94d1": "Share your thoughts...",
  "auto.volume-24h-828d": "Volume (24h)",
  "auto.summary-2906": "Summary",
  "auto.key-points-0c3f": "Key points",
  "auto.positioning-a52f": "Positioning",
  "auto.risk-factors-1572": "Risk factors",
  "auto.market-3184": "Market",
  "auto.price-drivers-ecd8": "Price drivers",
  "auto.competitive-landscape-4a0f": "Competitive landscape",
  "auto.adoption-985d": "Adoption",
  "auto.sentiment-f692": "Sentiment",
  "auto.technical-ad1e": "Technical",
  "auto.momentum-3732": "Momentum",
  "auto.development-activity-fe70": "Development activity",
  "auto.on-chain-metrics-f2bc": "On-chain metrics",
  "auto.outlook-038e": "Outlook",
  "auto.create-price-alert-5471": "Create price alert",
  "auto.skip-back-15-seconds-3196": "Skip back 15 seconds",
  "auto.total-market-cap-9c2c": "Total Market Cap",
  "auto.24h-volume-c4d0": "24h Volume",
  "auto.btc-dominance-2a46": "BTC Dominance",
  "auto.active-cryptos-ffc9": "Active Cryptos",
  "auto.nothing-to-see-here-yet-a18a": "Nothing to see here yet",
  "auto.when-you-follow-people-their-posts-will-4e18": "When you follow people, their posts will show up here.",
  "auto.the-feed-is-quiet-3196": "The feed is quiet...",
  "auto.there-are-no-posts-to-show-right-now-che-50f0": "There are no posts to show right now. Check back later!",
  "auto.no-articles-shared-with-you-yet-b032": "No articles shared with you yet",
  "auto.no-trending-topics-right-now-3638": "No trending topics right now.",
  "auto.no-new-suggestions-right-now-ad66": "No new suggestions right now.",
  "auto.connecting-to-game-f48a": "Connecting to game...",
  "auto.players-alive-a11c": "Players Alive:",
  "auto.time-421b": "Time:",
  "auto.wasd-or-joystick-move-0938": "WASD or Joystick - Move",
  "auto.space-jump-2f3f": "Space - Jump",
  "auto.shift-dive-b431": "Shift - Dive",
  "auto.wawa-guys-2e36": "Wawa Guys",
  "auto.change-language-91d6": "Change language",
  "auto.accuracy-d78f": "Accuracy",
  "auto.forecasts-46e2": "Forecasts",
  "auto.followers-24c7": "Followers",
  "auto.win-rate-07a5": "Win Rate",
  "auto.verified-analyst-with-confirmed-identity-d570": "Verified analyst with confirmed identity",
  "auto.verification-request-under-review-232b": "Verification request under review",
  "auto.markdown-supported-9516": "Markdown supported",
  "auto.nothing-to-preview-a045": "Nothing to preview",
  "auto.analyst-confidence-a744": "Analyst confidence",
  "auto.loading-8524": "Loading...",
  "auto.price-3601": "Price",
  "auto.ask-about-this-token-a228": "Ask about this token...",
  "auto.custom-amount-eb30": "Custom Amount",
  "auto.resolved-f691": "Resolved",
  "auto.correct-d0a3": "Correct",
  "auto.partial-44ff": "Partial",
  "auto.incorrect-a94d": "Incorrect",
  "auto.pending-2d13": "Pending",
  "auto.no-submissions-yet-7db1": "No submissions yet.",
  "auto.ai-judge-f6d9": "AI judge:",
  "auto.submissions-are-closed-awaiting-resoluti-0f50": "Submissions are closed. Awaiting resolution.",
  "auto.your-analysis-bb53": "Your analysis",
  "auto.one-submission-per-event-editable-until-65e5": "One submission per event. Editable until the deadline. Hidden from others until resolution.",
  "auto.your-prediction-037c": "Your prediction",
  "auto.reasoning-thesis-a7da": "Reasoning / thesis",
  "auto.what-do-you-think-will-happen-3a4b": "What do you think will happen?",
  "auto.explain-your-reasoning-cite-sources-or-s-9553": "Explain your reasoning, cite sources or signals...",
  "auto.scoring-983f": "Scoring",
  "auto.how-points-work-3888": "How points work",
  "auto.scoring-rules-will-appear-here-82b7": "Scoring rules will appear here.",
  "auto.top-contributors-52e7": "Top contributors",
  "auto.full-rankings-466a": "Full rankings",
  "auto.player-636d": "Player",
  "auto.tier-9483": "Tier",
  "auto.streak-f4bb": "Streak",
  "auto.score-5dd1": "Score",
  "auto.search-players-827d": "Search players…",
  "auto.score-composition-3866": "Score composition",
  "auto.your-standing-c680": "Your standing",
  "auto.sign-in-b6d4": "Sign in",
  "auto.overall-progress-e9d5": "Overall Progress",
  "auto.learning-leaderboard-e1fa": "Learning Leaderboard",
  "auto.learning-rankings-ef2d": "Learning Rankings",
  "auto.progress-46b5": "Progress",
  "auto.out-of-lives-5b83": "Out of Lives!",
  "auto.until-next-life-66cd": "until next life",
  "auto.current-hearts-dcdf": "Current Hearts",
  "auto.how-it-works-07cb": "How it works:",
  "auto.your-completed-lessons-4475": "Your Completed Lessons",
  "auto.explanation-0bf1": "Explanation:",
  "auto.trending-3752": "Trending",
  "auto.top-gainers-0413": "Top Gainers",
  "auto.top-losers-d4cc": "Top Losers",
  "auto.recently-added-e1a4": "Recently Added",
  "auto.trend-structure-6f3d": "Trend structure",
  "auto.levels-91ae": "Levels",
  "auto.cryptos-843d": "Cryptos:",
  "auto.market-cap-ff0a": "Market Cap:",
  "auto.24h-vol-67f5": "24h Vol:",
  "auto.dominance-bc2e": "Dominance:",
  "auto.fear-greed-3bc6": "Fear & Greed:",
  "auto.name-49ee": "Name",
  "auto.market-cap-81c9": "Market Cap",
  "auto.circulating-supply-2a56": "Circulating Supply",
  "auto.last-7-days-4b29": "Last 7 Days",
  "auto.reset-sort-4673": "Reset sort",
  "auto.clear-date-range-2fb4": "Clear date range",
  "auto.remove-source-d074": "Remove source",
  "auto.search-articles-dd17": "Search articles",
  "auto.clear-search-9983": "Clear search",
  "auto.sort-articles-83b1": "Sort articles",
  "auto.filters-f3f4": "Filters",
  "auto.refresh-news-322e": "Refresh news",
  "auto.byteline-2fe0": "Byteline",
  "auto.exit-sphere-mode-dbd1": "Exit sphere mode",
  "auto.type-a-ticker-or-command-eq-nvda-mkt-new-6dda": "Type a ticker or command (eq NVDA · mkt · news b · port). Press / to focus.",
  "auto.loading-13d4": "loading...",
  "auto.no-coverage-found-acc2": "no coverage found",
  "auto.loading-wire-3635": "loading wire...",
  "auto.no-stories-15b2": "no stories",
  "auto.last-98bd": "last",
  "auto.download-episode-15a6": "Download episode",
  "auto.add-a-comment-9cf8": "Add a comment...",
  "auto.stop-playback-d968": "Stop playback",
  "auto.resolving-5e68": "Resolving",
  "auto.sentiment-a0b4": "Sentiment:",
  "auto.key-factors-a050": "Key Factors",
  "auto.total-vol-8020": "Total Vol.",
  "auto.24h-vol-0d59": "24h Vol.",
  "auto.liquidity-ced4": "Liquidity",
  "auto.set-price-alert-24fa": "Set price alert",
  "auto.no-market-data-available-32ee": "No market data available",
  "auto.ai-top-pick-201e": "AI Top Pick",
  "auto.ai-recommendation-6522": "AI Recommendation",
  "auto.outcome-cf73": "Outcome",
  "auto.chance-332f": "% Chance",
  "auto.ai-pick-dcd1": "AI Pick",
  "auto.trade-5f39": "Trade",
  "auto.select-outcome-2799": "Select Outcome",
  "auto.alert-when-price-goes-7231": "Alert when price goes",
  "auto.target-price-8689": "Target Price (%)",
  "auto.bull-case-2541": "Bull case",
  "auto.bear-case-c063": "Bear case",
  "auto.risks-d179": "Risks",
  "auto.no-live-arbitrage-opportunities-a3dc": "No live arbitrage opportunities.",
  "auto.regenerate-b232": "Regenerate",
  "auto.no-digest-yet-click-regenerate-d188": "No digest yet. Click Regenerate.",
  "auto.top-arbs-3030": "Top arbs",
  "auto.whale-moves-3d39": "Whale moves",
  "auto.probability-shifts-4de8": "Probability shifts",
  "auto.kalshi-a929": "Kalshi",
  "auto.polymarket-0fa9": "Polymarket",
  "auto.top-of-book-8930": "Top of book",
  "auto.orderbook-112f": "Orderbook",
  "auto.trades-18da": "Trades",
  "auto.enter-a-market-id-and-click-fetch-149d": "Enter a market_id and click Fetch.",
  "auto.market-id-af0e": "market_id",
  "auto.crypto-79ad": "Crypto",
  "auto.macro-4374": "Macro",
  "auto.waiting-for-messages-relay-session-lasts-f6a4": "Waiting for messages... (relay session lasts ~50s, reconnect by clicking again)",
  "auto.tap-to-view-markets-7ece": "Tap to view markets.",
  "auto.ask-anything-4686": "Ask anything...",
  "auto.order-ticket-0daa": "Order ticket",
  "auto.limit-price-49cc": "Limit price (¢)",
  "auto.shares-d272": "Shares",
  "auto.confirm-your-order-2d1b": "Confirm your order",
  "auto.cancel-ea47": "Cancel",
  "auto.select-an-outcome-9933": "Select an outcome",
  "auto.trading-with-real-money-carries-real-ris-acf0": "Trading with real money carries real risk.",
  "auto.eligibility-fb28": "Eligibility:",
  "auto.how-your-credentials-are-handled-e38d": "How your credentials are handled",
  "auto.disconnecting-a-venue-deletes-the-stored-3f3f": "Disconnecting a venue deletes the stored credentials immediately.",
  "auto.connect-kalshi-d258": "Connect Kalshi",
  "auto.api-key-id-6452": "API key ID",
  "auto.rsa-private-key-pem-b5cb": "RSA private key (PEM)",
  "auto.connect-polymarket-d376": "Connect Polymarket",
  "auto.polygon-private-key-afbf": "Polygon private key",
  "auto.track-events-to-see-whale-trades-here-7591": "Track events to see whale trades here.",
  "auto.interpret-ad79": "Interpret",
  "auto.click-interpret-to-classify-recent-whale-7e9f": "Click Interpret to classify recent whale trades.",
  "auto.go-premium-68e1": "Go Premium",
  "auto.refer-amp-earn-88de": "Refer &amp; Earn",
  "auto.sign-in-to-get-your-link-3a83": "Sign in to get your link",
  "auto.your-referral-link-9360": "Your referral link",
  "auto.copy-referral-link-b233": "Copy referral link",
  "auto.invited-aa34": "Invited",
  "auto.subscribed-808c": "Subscribed",
  "auto.earned-0c19": "Earned",
  "auto.0x-erc-20-or-t-trc-20-8ec0": "0x… (ERC-20) or T… (TRC-20)",
  "auto.search-tools-e30f": "Search tools...",
  "auto.custom-colour-ead5": "Custom colour",
  "auto.custom-body-colour-a281": "Custom body colour",
  "auto.owned-avatar-2136": "Owned avatar",
  "auto.delete-avatar-66e0": "Delete avatar",
  "auto.enter-your-display-name-c3d9": "Enter your display name",
  "auto.enter-your-username-dd62": "Enter your username",
  "auto.tell-us-about-yourself-490b": "Tell us about yourself...",
  "auto.streak-d832": "streak",
  "auto.what-s-on-your-mind-4a31": "What's on your mind?",
  "auto.edit-avatar-5dcd": "Edit avatar",
  "auto.edit-profile-dfd8": "Edit profile",
  "auto.supports-jpg-png-max-10mb-6dac": "Supports JPG, PNG (max 10MB)",
  "auto.uploaded-fe8d": "Uploaded",
  "auto.generated-avatar-f8c8": "Generated avatar",
  "auto.previous-post-bc9d": "Previous post",
  "auto.next-post-ebd8": "Next post",
  "auto.play-the-next-video-automatically-7ca8": "Play the next video automatically",
  "auto.play-this-video-a220": "Play this video",
  "auto.resume-video-3494": "Resume video",
  "auto.open-comments-b1b9": "Open comments",
  "auto.about-this-post-3fd2": "About this post",
  "auto.loading-videos-719c": "Loading videos",
  "auto.add-a-comment-c3ed": "Add a comment",
  "auto.delete-comment-547f": "Delete comment",
  "auto.share-this-issue-c878": "Share this issue",
  "auto.fear-amp-greed-6b78": "Fear &amp; Greed",
  "auto.fear-greed-a0e2": "Fear & Greed",
};

export const noAuto: Partial<Record<keyof typeof enAuto, string>> = {
  "auto.analyzing-article-sentiment": "Analyserer artikkelens stemning \u2026",
  "auto.share-article-a4bd": "Del artikkel",
  "auto.you-re-not-following-anyone-yet-04bb": "Du følger ingen ennå",
  "auto.follow-people-to-share-articles-with-the-2376": "Følg personer for å dele artikler med dem",
  "auto.please-sign-in-to-join-the-discussion-5b52": "Logg inn for å delta i diskusjonen",
  "auto.no-comments-yet-be-the-first-to-share-yo-849d": "Ingen kommentarer ennå. Vær den første til å si din mening!",
  "auto.price-3e82": "Pris",
  "auto.market-cap-690d": "Markedsverdi",
  "auto.fdv-488b": "FDV",
  "auto.circulating-supply-fea1": "Sirkulerende tilbud",
  "auto.ai-analysis-e639": "AI-analyse",
  "auto.markets-c3c4": "Markeder",
  "auto.latest-news-4e11": "Siste nytt",
  "auto.no-recent-news-available-c6d3": "Ingen ferske nyheter tilgjengelig",
  "auto.no-recent-news-found-3e77": "Ingen ferske nyheter funnet",
  "auto.loading-chart-data-8bde": "Laster inn diagramdata...",
  "auto.searching-ba2b": "Søker...",
  "auto.name-709a": "Navn",
  "auto.market-cap-d553": "Markedsverdi",
  "auto.actions-c3cd": "Handlinger",
  "auto.today-s-recap-will-be-available-soon-b12e": "Dagens oppsummering er snart klar",
  "auto.check-back-later-for-the-daily-summary-2ce9": "Kom tilbake senere for dagsoppsummeringen",
  "auto.no-articles-published-today-yet-e14c": "Ingen artikler publisert i dag ennå",
  "auto.no-data-available-0cfc": "Ingen data tilgjengelig",
  "auto.biggest-gainers-in-the-last-24-hours-b83d": "Største vinnere siste 24 timer",
  "auto.24h-volume-9aeb": "24t-volum",
  "auto.btc-dominance-8a7c": "BTC-dominans",
  "auto.active-cryptocurrencies-7399": "Aktive kryptovalutaer",
  "auto.updated-5-min-ago-9c8f": "Oppdatert for 5 min siden",
  "auto.ai-briefing-is-unavailable-right-now-b56b": "AI-briefing er utilgjengelig akkurat nå.",
  "auto.loading-33ce": "Laster inn…",
  "auto.live-65c8": "Direkte",
  "auto.loading-live-markets-f335": "Laster inn sanntidsmarkeder…",
  "auto.sort-adc4": "Sorter",
  "auto.no-sources-available-yet-59f8": "Ingen kilder tilgjengelig ennå.",
  "auto.sign-in-to-leave-a-comment-e697": "Logg inn for å legge igjen en kommentar",
  "auto.achievements-a663": "Prestasjoner",
  "auto.reward-c7d7": "Belønning",
  "auto.your-activity-7540": "Din aktivitet",
  "auto.browse-web3-tools-dapps-1c3b": "Utforsk Web3-verktøy og DApps",
  "auto.crypto-enthusiast-2e1a": "Kryptoentusiast",
  "auto.skin-tone-6375": "Hudtone",
  "auto.body-style-9e5b": "Kroppstype",
  "auto.avatar-studio-25ae": "Avatarstudio",
  "auto.character-ee99": "Karakter",
  "auto.body-colour-176d": "Kroppsfarge",
  "auto.cached-colours-are-free-xp-is-charged-on-3941": "Bufrede farger er gratis. XP belastes bare når Nano Banana 3 oppretter en ny farge.",
  "auto.background-64dd": "Bakgrunn",
  "auto.your-collection-f01e": "Samlingen din",
  "auto.delete-this-avatar-fabf": "Slette denne avataren?",
  "auto.cancel-77df": "Avbryt",
  "auto.hair-style-fd9c": "Frisyre",
  "auto.eye-color-68a3": "Øyenfarge",
  "auto.accessories-f3b5": "Tilbehør",
  "auto.facial-hair-c8d1": "Ansiktshår",
  "auto.no-recent-celebrations-a3a5": "Ingen nylige feiringer",
  "auto.commented-on-article-bf0a": "Kommenterte en artikkel",
  "auto.loading-recaps-5b84": "Laster inn oppsummeringer...",
  "auto.no-daily-recap-available-yet-13c7": "Ingen dagsoppsummering tilgjengelig ennå",
  "auto.daily-recap-queue-96b8": "Kø for dagsoppsummering",
  "auto.today-s-recap-a23d": "Dagens oppsummering",
  "auto.today-s-daily-recap-4864": "Dagens oppsummering",
  "auto.new-eee2": "Ny!",
  "auto.daily-recap-b0b4": "Daglig oppsummering",
  "auto.edit-profile-cd28": "Rediger profil",
  "auto.display-name-8d6b": "Visningsnavn",
  "auto.username-84c2": "Brukernavn",
  "auto.bio-b31f": "Bio",
  "auto.statistics-2086": "Statistikk",
  "auto.no-profile-data-available-07b3": "Ingen profildata tilgjengelig",
  "auto.day-streak-350f": "Dager på rad",
  "auto.total-xp-de22": "Total XP",
  "auto.current-league-4376": "Nåværende liga",
  "auto.your-benefits-03dd": "Dine fordeler:",
  "auto.view-forecasts-a04d": "Se prognoser",
  "auto.browse-analyst-predictions-7c40": "Utforsk analytikerprognoser",
  "auto.create-content-dfb9": "Opprett innhold",
  "auto.publish-forecasts-analysis-4da4": "Publiser prognoser og analyser",
  "auto.commented-on-a-podcast-episode-29be": "kommenterte en podkastepisode",
  "auto.share-your-thoughts-af96": "Del dine tanker",
  "auto.following-90ee": "Følger",
  "auto.followers-78ea": "Følgere",
  "auto.edit-avatar-4ea4": "Rediger avatar",
  "auto.your-stats-427c": "Din statistikk",
  "auto.points-4b2a": "Poeng",
  "auto.day-streak-ca4b": "Dager på rad",
  "auto.league-7096": "Liga",
  "auto.earn-points-a33f": "Tjen poeng",
  "auto.read-an-article-79a7": "Les en artikkel",
  "auto.5-pts-ef93": "+5 poeng",
  "auto.comment-on-article-378d": "Kommenter på en artikkel",
  "auto.10-pts-3247": "+10 poeng",
  "auto.create-a-post-8421": "Opprett et innlegg",
  "auto.15-pts-1cca": "+15 poeng",
  "auto.browse-pages-eb8e": "Utforsk sider",
  "auto.1-pt-4a3f": "+1 poeng",
  "auto.wall-c463": "Vegg",
  "auto.watchlist-48a6": "Overvåkningsliste",
  "auto.tools-4fa8": "Verktøy",
  "auto.web3-tools-dapps-288d": "Web3-verktøy og DApps",
  "auto.no-web3-tools-added-yet-a318": "Ingen Web3-verktøy lagt til ennå",
  "auto.no-tokens-in-watchlist-0783": "Ingen tokens i overvåkningslisten",
  "auto.your-watchlist-ba90": "Din overvåkningsliste",
  "auto.ai-avatar-generator-4e96": "AI-avatargenerator",
  "auto.upload-your-photo-3a43": "Last opp bildet ditt",
  "auto.drop-your-photo-here-or-56ec": "Dra og slipp bildet her, eller",
  "auto.your-generated-avatar-177c": "Din genererte avatar",
  "auto.filters-96e5": "Filtre",
  "auto.date-range-6bb4": "Datoperiode",
  "auto.sources-2eb5": "Kilder",
  "auto.categories-6ccb": "Kategorier",
  "auto.loading-suggestions-7645": "Laster inn forslag...",
  "auto.this-one-cannot-be-played-here-c71c": "Denne kan ikke spilles av her.",
  "auto.tap-for-sound-a80b": "Trykk for lyd",
  "auto.comments-fce0": "Kommentarer",
  "auto.about-6b21": "Om",
  "auto.no-comments-yet-207b": "Ingen kommentarer ennå.",
  "auto.quick-quiz-648f": "Kjapp quiz",
  "auto.editor-s-note-ffa0": "Redaktørens notat",
  "auto.past-issues-6510": "Tidligere utgaver",
  "auto.market-pulse-ff2f": "Markedspuls",
  "auto.crypto-e849": "Krypto",
  "auto.narrative-of-the-week-60f4": "Ukens narrativ",
  "auto.top-stories-1fa6": "Toppsaker",
  "auto.listen-this-week-dda7": "Hør denne uken",
  "auto.movers-7-day-5599": "Bevegelser, 7 dager",
  "auto.winners-1d50": "Vinnere",
  "auto.losers-6ce7": "Tapere",
  "auto.what-we-publish-c716": "Hva vi publiserer",
  "auto.daily-recap-of-the-stories-that-moved-th-d0dc": "Daglig oppsummering av sakene som preget sektoren.",
  "auto.weekly-brief-with-the-themes-behind-the-951f": "Ukentlig brief med temaene bak overskriftene.",
  "auto.market-pages-for-crypto-assets-and-techn-2777": "Markedssider for kryptoaktiva og teknologiaksjer.",
  "auto.topic-guides-explaining-recurring-subjec-abfd": "Temaguider som forklarer tilbakevendende emner på en enkel måte.",
  "auto.ownership-and-funding-be43": "Eierskap og finansiering",
  "auto.contact-b374": "Kontakt",
  "auto.article-not-found-39d5": "Artikkelen ble ikke funnet",
  "auto.return-to-home-7d70": "Tilbake til forsiden",
  "auto.admin-panel-9371": "Adminpanel",
  "auto.this-article-has-been-translated-677d": "Denne artikkelen er oversatt",
  "auto.related-articles-cfd2": "Relaterte artikler",
  "auto.source-6da1": "Kilde",
  "auto.no-recent-stories-for-this-writer-e862": "Ingen nylige saker fra denne forfatteren.",
  "auto.login-to-view-bookmarks-cec4": "Logg inn for å se bokmerker",
  "auto.login-4e5a": "Logg inn",
  "auto.no-bookmarks-yet-aaf8": "Ingen bokmerker ennå",
  "auto.browse-articles-6cc4": "Utforsk artikler",
  "auto.no-lessons-available-yet-f1e3": "Ingen leksjoner tilgjengelig ennå",
  "auto.need-hearts-bfc9": "Trenger du hjerter?",
  "auto.your-progress-9839": "Din fremgang",
  "auto.completion-2ff2": "Fullført",
  "auto.streak-ac47": "Streak",
  "auto.sourcing-and-credit-1c70": "Kildebruk og kreditering",
  "auto.use-of-artificial-intelligence-0101": "Bruk av kunstig intelligens",
  "auto.verification-0312": "Verifisering",
  "auto.corrections-ccc7": "Rettelser",
  "auto.independence-1db5": "Uavhengighet",
  "auto.episode-not-found-8ce5": "Episoden ble ikke funnet",
  "auto.show-notes-5699": "Episodenotater",
  "auto.your-feed-awaits-8973": "Feeden din venter",
  "auto.sign-in-f849": "Logg inn",
  "auto.for-you-7e13": "For deg",
  "auto.shared-with-you-72f2": "Delt med deg",
  "auto.start-playing-54ff": "Spill nå",
  "auto.create-room-7a91": "Opprett rom",
  "auto.join-room-902f": "Bli med i rom",
  "auto.how-to-play-9686": "Slik spiller du",
  "auto.create-or-join-cf74": "Opprett eller bli med",
  "auto.wait-for-players-2b50": "Vent på spillere",
  "auto.race-to-win-fcd6": "Kjemp om seieren!",
  "auto.game-not-found-e875": "Spillet ble ikke funnet",
  "auto.room-d295": "Rom:",
  "auto.loading-game-0a6b": "Laster inn spill...",
  "auto.games-398e": "Spill",
  "auto.max-players-77c3": "Maks antall spillere",
  "auto.win-xp-ff81": "Vinn XP",
  "auto.subscribe-now-378b": "Abonner nå",
  "auto.browse-forecasts-2c04": "Utforsk prognoser",
  "auto.why-intelligence-pro-2b11": "Hvorfor Intelligence Pro?",
  "auto.verified-track-records-82ee": "Verifiserte resultater",
  "auto.halal-compliant-1ba3": "Halal-kompatibel",
  "auto.ai-research-co-pilot-82f3": "AI Research Co-Pilot",
  "auto.top-analysts-4304": "Toppanalytikere",
  "auto.view-all-931e": "Se alle",
  "auto.recent-forecasts-ea5d": "Nylige prognoser",
  "auto.analyst-not-found-2f77": "Fant ikke analytiker",
  "auto.back-to-analysts-7e2c": "Tilbake til analytikere",
  "auto.analyst-profile-502b": "Analytikerprofil",
  "auto.total-forecasts-7645": "Prognoser totalt",
  "auto.win-rate-49a3": "Treffprosent",
  "auto.brier-score-fa35": "Brier-score",
  "auto.theses-0164": "Teser",
  "auto.playbooks-01e7": "Playbooks",
  "auto.post-mortems-75ec": "Etteranalyser",
  "auto.no-forecasts-yet-c7f3": "Ingen prognoser ennå",
  "auto.no-theses-yet-9967": "Ingen teser ennå",
  "auto.no-playbooks-yet-315b": "Ingen playbooks ennå",
  "auto.no-post-mortems-yet-0e17": "Ingen etteranalyser ennå",
  "auto.active-analysts-f8dd": "Aktive analytikere",
  "auto.avg-accuracy-a5a5": "Gj.snittlig treffsikkerhet",
  "auto.total-followers-4db2": "Følgere totalt",
  "auto.no-analysts-yet-d76d": "Ingen analytikere ennå",
  "auto.accuracy-12a3": "Treffsikkerhet",
  "auto.avg-brier-b28a": "Gj.snittlig Brier",
  "auto.top-token-cd22": "Beste token",
  "auto.analysts-5c55": "Analytikere",
  "auto.this-week-4e68": "Denne uken",
  "auto.accuracy-trends-efd8": "Treffsikkerhetstrender",
  "auto.prediction-types-c45b": "Prediksjonstyper",
  "auto.token-performance-958c": "Token-ytelse",
  "auto.token-a114": "Token",
  "auto.forecasts-1685": "Prognoser",
  "auto.avg-confidence-0fb3": "Gj.snittlig konfidens",
  "auto.checking-access-b7a3": "Sjekker tilgang...",
  "auto.content-type-863e": "Innholdstype",
  "auto.new-forecast-25b1": "Ny prognose",
  "auto.token-symbol-89a4": "Tokensymbol",
  "auto.prediction-type-343a": "Prediksjonstype",
  "auto.price-above-548f": "Pris over",
  "auto.price-below-36c2": "Pris under",
  "auto.change-6324": "% endring",
  "auto.target-date-befd": "Måldato",
  "auto.premium-only-97e5": "Kun Premium",
  "auto.title-768e": "Tittel",
  "auto.loading-b04b": "Laster...",
  "auto.event-not-found-0f7c": "Fant ikke hendelsen.",
  "auto.resolved-d999": "Avgjort",
  "auto.this-event-requires-ba95": "Denne hendelsen krever",
  "auto.tier-access-15c9": "nivåtilgang.",
  "auto.upgrade-subscription-a8c7": "Oppgrader abonnement",
  "auto.sign-in-to-submit-your-analysis-68fe": "Logg inn for å sende inn analysen din.",
  "auto.ai-analysis-resolution-93b9": "AI-analyse og avgjørelse",
  "auto.outcome-d3f0": "Utfall",
  "auto.ai-pre-resolution-analysis-f91e": "AI-analyse før avgjørelse",
  "auto.all-submissions-4ff2": "Alle innsendinger",
  "auto.forecast-not-found-28fe": "Fant ikke prognosen",
  "auto.back-to-forecasts-bd16": "Tilbake til prognoser",
  "auto.open-cf9b": "Åpen",
  "auto.correct-48e0": "Riktig",
  "auto.incorrect-7831": "Feil",
  "auto.expired-a689": "Utløpt",
  "auto.forecast-detail-7798": "Prognosedetaljer",
  "auto.confidence-82fa": "Konfidens",
  "auto.price-at-creation-b02e": "Pris ved opprettelse",
  "auto.target-price-9bf8": "Målpris",
  "auto.outcome-analysis-367b": "Utfallsanalyse",
  "auto.unlock-with-pro-5bed": "Lås opp med Pro",
  "auto.my-submissions-15c8": "Mine bidrag",
  "auto.by-accuracy-d903": "Etter nøyaktighet",
  "auto.by-brier-score-9e6f": "Etter Brier-score",
  "auto.by-forecasts-dafd": "Etter prognoser",
  "auto.by-followers-eea2": "Etter følgere",
  "auto.top-performers-9693": "Beste utøvere",
  "auto.full-rankings-2acb": "Fullstendig rangering",
  "auto.brier-e8ca": "Brier",
  "auto.get-started-bd2c": "Kom i gang",
  "auto.you-re-already-an-analyst-b48e": "Du er allerede analytiker!",
  "auto.check-eligibility-0fae": "Sjekk kvalifikasjon",
  "auto.intelligence-pro-or-elite-subscription-38e0": "Intelligence Pro- eller Elite-abonnement",
  "auto.verified-account-0051": "Verifisert konto",
  "auto.your-email-is-verified-2ec3": "E-posten din er verifisert",
  "auto.create-your-profile-a092": "Opprett profilen din",
  "auto.back-b52b": "Tilbake",
  "auto.add-details-f773": "Legg til detaljer",
  "auto.specialties-1b0c": "Spesialiteter",
  "auto.review-confirm-eabb": "Gå gjennom og bekreft",
  "auto.profile-completion-e328": "Profilfullføring",
  "auto.post-not-found-2a87": "Innlegget ble ikke funnet",
  "auto.back-to-intelligence-ad5d": "Tilbake til Intelligence",
  "auto.lessons-learned-e41d": "Erfaringer",
  "auto.scenarios-2dd4": "Scenarioer",
  "auto.cancel-anytime-51e2": "Kanseller når som helst",
  "auto.30-day-refund-568a": "30 dagers refusjon",
  "auto.all-time-dbad": "Hele perioden",
  "auto.month-082b": "Måned",
  "auto.week-f82b": "Uke",
  "auto.market-watch-85d4": "Markedsoversikt",
  "auto.currently-tracking-7267": "Sporer for øyeblikket",
  "auto.analysis-made-61f8": "Analyser utført",
  "auto.ai-consensus-b979": "AI-konsensus",
  "auto.no-picks-yet-1019": "Ingen tips ennå",
  "auto.top-picks-f1cb": "Toppvalg",
  "auto.all-markets-8582": "Alle markeder",
  "auto.recent-trades-2843": "Nylige handler",
  "auto.current-price-2f9f": "Nåværende pris",
  "auto.volume-3b18": "Volum",
  "auto.ai-analysis-1569": "AI-analyse:",
  "auto.status-bae7": "Status",
  "auto.search-for-what-you-need-7d5b": "Søk etter det du trenger",
  "auto.podcast-not-found-c941": "Podkasten ble ikke funnet",
  "auto.prediction-markets-c6ca": "Prediksjonsmarkeder",
  "auto.updating-3ab0": "Oppdaterer…",
  "auto.all-events-7f14": "Alle hendelser",
  "auto.bookmarks-ca3c": "Bokmerker",
  "auto.no-active-alerts-7617": "Ingen aktive varsler",
  "auto.event-not-found-231b": "Hendelsen ble ikke funnet",
  "auto.total-vol-7a36": "Totalt vol.",
  "auto.24h-vol-d841": "24t vol.",
  "auto.liquidity-76a3": "Likviditet",
  "auto.featured-ae31": "Fremhevet",
  "auto.probability-chart-1fba": "Sannsynlighetsdiagram",
  "auto.outcomes-6848": "Utfall",
  "auto.trade-b081": "Handle",
  "auto.outcome-probabilities-86db": "Utfallssannsynligheter",
  "auto.no-markets-returned-b8e1": "Ingen markeder funnet.",
  "auto.digest-47fd": "Sammendrag",
  "auto.historical-bb2f": "Historisk",
  "auto.account-85df": "Konto",
  "auto.sort-volume-b0aa": "Sorter: Volum",
  "auto.sort-liquidity-d93a": "Sorter: Likviditet",
  "auto.sort-markets-5083": "Sorter: Markeder",
  "auto.sort-newest-682d": "Sorter: Nyeste",
  "auto.your-watchlist-b916": "Din overvåkningsliste",
  "auto.sign-in-to-track-events-and-build-a-watc-50f5": "Logg inn for å følge hendelser og bygge en overvåkningsliste.",
  "auto.ai-market-copilot-3694": "AI Market Copilot",
  "auto.no-bookmarked-events-yet-0429": "Ingen lagrede hendelser ennå.",
  "auto.membership-53bc": "Medlemskap",
  "auto.month-f7fa": "/ måned",
  "auto.why-members-upgrade-74cc": "Hvorfor medlemmer oppgraderer",
  "auto.questions-9a1f": "Spørsmål",
  "auto.billing-cancellation-and-payouts-ce6e": "Fakturering, oppsigelse og utbetalinger.",
  "auto.couldn-t-load-press-releases-2907": "Kunne ikke laste inn pressemeldinger",
  "auto.no-press-releases-yet-4851": "Ingen pressemeldinger ennå.",
  "auto.information-we-collect-ca19": "Informasjon vi samler inn",
  "auto.account-details-804f": "Kontodetaljer.",
  "auto.things-you-create-3254": "Ting du oppretter.",
  "auto.usage-data-e2b4": "Bruksdata.",
  "auto.messages-you-send-us-47d6": "Meldinger du sender oss.",
  "auto.how-we-use-it-7f88": "Hvordan vi bruker det",
  "auto.cookies-and-analytics-9285": "Informasjonskapsler og analyse",
  "auto.third-party-services-871d": "Tredjepartstjenester",
  "auto.keeping-and-deleting-data-8d29": "Lagring og sletting av data",
  "auto.your-rights-e711": "Dine rettigheter",
  "auto.children-dcf7": "Barn",
  "auto.changes-8aa5": "Endringer",
  "auto.profile-not-available-d9c0": "Profilen er ikke tilgjengelig",
  "auto.nothing-here-yet-e892": "Ingenting her ennå",
  "auto.your-account-4ab2": "Din konto",
  "auto.acceptable-use-009a": "Akseptabel bruk",
  "auto.do-not-post-unlawful-hateful-misleading-0923": "Ikke legg ut ulovlig, hatefullt, misvisende eller krenkende materiale.",
  "auto.do-not-spam-scrape-in-bulk-or-attempt-to-977a": "Ikke spam, skrap i bulk eller forsøk å ødelegge eller overbelaste nettstedet.",
  "auto.do-not-impersonate-other-people-or-misre-bd33": "Ikke utgi deg for å være andre personer eller feilaktig fremstill din tilknytning.",
  "auto.do-not-upload-content-you-do-not-have-th-0818": "Ikke last opp innhold du ikke har rett til å dele.",
  "auto.content-you-post-5d23": "Innhold du legger ut",
  "auto.our-content-01c1": "Vårt innhold",
  "auto.not-financial-advice-2a1f": "Ikke finansiell rådgivning",
  "auto.subscriptions-and-payments-e507": "Abonnementer og betalinger",
  "auto.third-party-material-and-links-5f0d": "Tredjepartsmateriale og lenker",
  "auto.availability-and-liability-5aca": "Tilgjengelighet og ansvar",
  "auto.token-not-found-e894": "Token ikke funnet",
  "auto.this-topic-does-not-exist-or-is-not-publ-8eb4": "Dette emnet finnes ikke eller er ikke publisert ennå.",
  "auto.browse-all-topics-773a": "Utforsk alle emner",
  "auto.common-questions-f07a": "Vanlige spørsmål",
  "auto.related-topics-25bd": "Relaterte emner",
  "auto.supported-0bf8": "Støttes",
  "auto.not-supported-in-this-browser-fb69": "Støttes ikke i denne nettleseren",
  "auto.connect-an-outside-assistant-bb33": "Koble til en ekstern assistent",
  "auto.add-this-address-as-an-mcp-server-in-cha-7a2a": "Legg til denne adressen som en MCP-server i ChatGPT, Claude, Cursor eller en hvilken som helst annen MCP-klient.",

  "auto.writer-bbad": "Skribent",
  "auto.library-4d70": "Bibliotek",
  "auto.your-bookmarks-2e4c": "Dine bokmerker",
  "auto.access-all-your-saved-articles-in-one-pl-f162": "Få tilgang til alle de lagrede artiklene dine på ett sted.",
  "auto.today-in-crypto-d5e1": "Krypto i dag",
  "auto.refresh-daily-data-db90": "Oppdater daglige data",
  "auto.social-f431": "Sosialt",
  "auto.your-feed-a02e": "Din feed",
  "auto.posts-comments-and-activity-from-people-fef8": "Innlegg, kommentarer og aktivitet fra personer du følger.",
  "auto.search-posts-people-839f": "Søk etter innlegg og personer...",
  "auto.room-code-a1a2": "ROMKODE",
  "auto.multiplayer-901a": "Flerspiller",
  "auto.games-251b": "Spill",
  "auto.play-multiplayer-games-with-the-byteline-57d0": "Spill flerspillerspill med Byteline-fellesskapet. Konkurrer, ha det gøy og opptjen XP.",
  "auto.no-games-available-4e8d": "Ingen spill tilgjengelig",
  "auto.check-back-soon-for-new-games-4152": "Sjekk innom igjen snart for nye spill.",
  "auto.intelligence-pro-3e16": "Intelligence Pro",
  "auto.crypto-research-social-network-496e": "Sosialt nettverk for kryptoanalyse",
  "auto.follow-top-analysts-track-their-performa-85e2": "Følg toppanalytikere, spor resultatene deres og få tilgang til førsteklasses analyser. Bygg omdømmet ditt gjennom verifisert treffsikkerhet.",
  "auto.rankings-0d93": "Rangeringer",
  "auto.top-analysts-0d57": "Toppanalytikere",
  "auto.ranked-by-forecast-accuracy-and-track-re-bd75": "Rangert etter treffsikkerhet på prognoser og historiske resultater.",
  "auto.confidence-vs-accuracy-calibration-25d4": "Konfidens vs. treffsikkerhet (kalibrering)",
  "auto.intelligence-8f7b": "Intelligence",
  "auto.forecast-analytics-8780": "Prognoseanalyse",
  "auto.comprehensive-analytics-on-prediction-ac-0924": "Omfattende analyse av treffsikkerhet på spådommer, tokenytelse og analytikermønstre.",
  "auto.target-value-b95e": "Målverdi ($)",
  "auto.investment-thesis-markdown-supported-d34a": "Investeringstese (Markdown støttes)",
  "auto.content-markdown-supported-2067": "Innhold (Markdown støttes)",
  "auto.create-content-2e8b": "Opprett innhold",
  "auto.publish-a-forecast-thesis-playbook-or-ot-b927": "Publiser en prognose, tese, strategi eller annen analyse.",
  "auto.enter-a-compelling-title-57a5": "Skriv inn en fengende tittel...",
  "auto.weekly-events-986a": "Ukentlige hendelser",
  "auto.intelligence-events-f7ab": "Intelligence-hendelser",
  "auto.ai-curated-weekly-events-submit-your-ana-9dcf": "AI-kuraterte ukentlige hendelser. Send inn din analyse. Analytikere som tipper riktig, tjener fra plattformens belønningspott ved avklaring.",
  "auto.intelligence-leaderboard-94f8": "Intelligence-ledertavle",
  "auto.top-performing-analysts-ranked-by-predic-e50c": "Beste analytikere rangert etter treffsikkerhet på spådommer, Brier-score og historiske resultater.",
  "auto.display-name-f5f9": "Visningsnavn *",
  "auto.bio-b3eb": "Bio *",
  "auto.twitter-x-optional-9850": "Twitter/X (valgfritt)",
  "auto.telegram-optional-5a3a": "Telegram (valgfritt)",
  "auto.become-an-analyst-c1cc": "Bli analytiker",
  "auto.join-intelligence-pro-and-share-your-cry-fa3a": "Bli med i Intelligence Pro og del din kryptoinnsikt med fellesskapet.",
  "auto.your-analyst-name-4ba7": "Ditt analytikernavn",
  "auto.tell-others-about-your-experience-and-ex-f227": "Fortell andre om din erfaring og ekspertise (minst 100 tegn)",
  "auto.username-94b0": "@brukernavn",
  "auto.go-back-22b6": "Gå tilbake",
  "auto.choose-your-plan-6389": "Velg abonnement",
  "auto.unlock-premium-crypto-research-create-fo-5b58": "Lås opp premium kryptoanalyse, opprett prognoser og få tilgang til AI Research Co-Pilot.",
  "auto.bytelline-e3c9": "Bytelline",
  "auto.leaderboard-e02b": "Ledertabell",
  "auto.one-ranking-reading-learning-forecasting-5ec8": "Én rangering. Lesing, læring, prognoser og bidrag, kombinert.",
  "auto.active-players-2a28": "Aktive spillere",
  "auto.top-score-356a": "Toppscore",
  "auto.learn-2f1a": "Lær",
  "auto.web3-learning-2978": "Web3-læring",
  "auto.choose-a-path-to-start-your-journey-into-527b": "Velg en sti for å starte reisen din innen Web3 og blokkjedeteknologi.",
  "auto.no-learning-paths-yet-8f21": "Ingen læringsstier ennå",
  "auto.new-courses-are-on-the-way-2f85": "Nye kurs er på vei.",
  "auto.plus-d7d1": "pluss",
  "auto.podcasts-byteline-6720": "Podkaster – Byteline",
  "auto.discover-and-listen-to-the-sharpest-show-3071": "Oppdag og lytt til de skarpeste programmene om teknologi, markeder og innovasjon.",
  "auto.audio-b22f": "Lyd",
  "auto.podcasts-9bf7": "Podkaster",
  "auto.search-podcasts-f4ab": "Søk etter podkaster...",
  "auto.search-podcasts-11ca": "Søk etter podkaster",
  "auto.no-podcasts-found-39d2": "Ingen podkaster funnet",
  "auto.try-a-different-search-term-7f51": "Prøv et annet søkeord.",
  "auto.crypto-finance-markets-91ab": "Krypto- og finansmarkeder",
  "auto.track-crypto-and-finance-prediction-mark-56ea": "Følg krypto- og finansprediksjonsmarkeder.",
  "auto.sync-events-0d77": "Synkroniser hendelser",
  "auto.delete-alert-314c": "Slett varsel",
  "auto.search-events-b514": "Søk etter hendelser...",
  "auto.prediction-markets-b485": "Prediksjonsmarkeder",
  "auto.market-intelligence-abf2": "Markedsinnsikt",
  "auto.unified-view-of-global-event-markets-liv-8642": "Helhetlig oversikt over globale hendelsesmarkeder, sanntidspriser, volum og AI-assistert research på tvers av Kalshi og Polymarket.",
  "auto.search-events-e-g-bitcoin-fed-election-eca7": "Søk etter hendelser, f.eks. bitcoin, fed, valg…",
  "auto.you-apos-re-on-premium-03b7": "Du har Premium",
  "auto.upgrade-f683": "Oppgrader",
  "auto.premium-8d5e": "Premium",
  "auto.full-text-reading-ai-briefings-and-the-c-0e22": "Lesing i fulltekst, AI-briefinger og det komplette Byteline-arkivet for $3 i måneden.",
  "auto.press-releases-byteline-3e54": "Pressemeldinger | Byteline",
  "auto.company-announcements-partnerships-and-f-e620": "Selskapskunngjøringer, partnerskap og finansieringsnyheter sendt til Byteline, publisert som de er mottatt.",
  "auto.press-releases-01d7": "Pressemeldinger",
  "auto.announcements-submitted-by-companies-and-ae2d": "Kunngjøringer fra selskaper og deres representanter. Dette er ikke redaksjonelle saker fra Bytelines redaksjon.",
  "auto.search-1334": "Søk",
  "auto.search-articles-e8de": "Søk i artikler",
  "auto.search-articles-85ee": "Søk i artikler...",
  "auto.social-byteline-f2fc": "Sosiale medier – Byteline",
  "auto.creators-we-follow-on-tiktok-and-instagr-9fb9": "Innholdsskapere vi følger på TikTok og Instagram, som dekker teknologi, markeder og innovasjon.",
  "auto.markets-52c3": "Markeder",
  "auto.live-crypto-prices-tech-equities-top-mov-a4b1": "Kryptopriser i sanntid, teknologiaksjer, største bevegelser og overvåkningslisten din på ett sted.",
  "auto.search-name-or-symbol-b00d": "Søk etter navn eller symbol",
  "auto.topic-not-found-byteline-3c3a": "Emne ikke funnet | Byteline",
  "auto.this-topic-does-not-exist-4f31": "Dette emnet eksisterer ikke.",
  "auto.topic-not-found-74e6": "Emne ikke funnet",
  "auto.topics-34ac": "Emner",
  "auto.topics-byteline-d09e": "Emner | Byteline",
  "auto.guides-and-the-latest-coverage-across-ai-dec6": "Guider og siste nytt innen AI, halvledere, robotikk, romfart, bioteknologi, markeder, krypto og mer.",
  "auto.plain-english-guides-to-the-technologies-a483": "Lettfattelige guider til teknologiene og markedene vi dekker, med de nyeste sakene om hver av dem.",
  "auto.ai-connect-webmcp-8b29": "AI Connect (WebMCP)",
  "auto.weekly-brief-fc26": "Ukentlig brief",
  "auto.no-brief-published-yet-d245": "Ingen brief publisert ennå",
  "auto.the-first-weekly-brief-will-appear-here-6718": "Den første ukentlige briefen vil vises her så snart den er generert.",
  "auto.something-went-wrong-6609": "Noe gikk galt",
  "auto.skip-backward-15-seconds-4da1": "Hopp 15 sekunder tilbake",
  "auto.skip-forward-15-seconds-087f": "Hopp 15 sekunder frem",
  "auto.share-5a95": "Del",
  "auto.why-are-you-sharing-this-1535": "Hvorfor deler du dette?",
  "auto.sign-in-f2fd": "Logg inn",
  "auto.sign-up-d678": "Registrer deg",
  "auto.email-ce8a": "E-post",
  "auto.password-dc64": "Passord",
  "auto.full-name-6300": "Fullt navn",
  "auto.you-example-com-4fca": "du@eksempel.no",
  "auto.john-doe-4c2a": "Ola Nordmann",
  "auto.members-only-1fbc": "Kun for medlemmer",
  "auto.log-out-4394": "Logg ut",
  "auto.share-your-thoughts-94d1": "Del tankene dine...",
  "auto.volume-24h-828d": "Volum (24t)",
  "auto.summary-2906": "Sammendrag",
  "auto.key-points-0c3f": "Hovedpunkter",
  "auto.positioning-a52f": "Posisjonering",
  "auto.risk-factors-1572": "Risikofaktorer",
  "auto.market-3184": "Marked",
  "auto.price-drivers-ecd8": "Prisdrivere",
  "auto.competitive-landscape-4a0f": "Konkurransebilde",
  "auto.adoption-985d": "Adopsjon",
  "auto.sentiment-f692": "Sentiment",
  "auto.technical-ad1e": "Teknisk",
  "auto.momentum-3732": "Momentum",
  "auto.development-activity-fe70": "Utviklingsaktivitet",
  "auto.on-chain-metrics-f2bc": "On-chain-målinger",
  "auto.outlook-038e": "Utsikter",
  "auto.create-price-alert-5471": "Opprett prisvarsel",
  "auto.skip-back-15-seconds-3196": "Spol 15 sekunder tilbake",
  "auto.total-market-cap-9c2c": "Total markedsverdi",
  "auto.24h-volume-c4d0": "24t-volum",
  "auto.btc-dominance-2a46": "BTC-dominans",
  "auto.active-cryptos-ffc9": "Aktive kryptovalutaer",
  "auto.nothing-to-see-here-yet-a18a": "Ingenting å se her ennå",
  "auto.when-you-follow-people-their-posts-will-4e18": "Når du følger folk, vil innleggene deres vises her.",
  "auto.the-feed-is-quiet-3196": "Feeden er stille...",
  "auto.there-are-no-posts-to-show-right-now-che-50f0": "Det er ingen innlegg å vise akkurat nå. Sjekk igjen senere!",
  "auto.no-articles-shared-with-you-yet-b032": "Ingen artikler delt med deg ennå",
  "auto.no-trending-topics-right-now-3638": "Ingen populære emner akkurat nå.",
  "auto.no-new-suggestions-right-now-ad66": "Ingen nye forslag akkurat nå.",
  "auto.connecting-to-game-f48a": "Kobler til spill...",
  "auto.players-alive-a11c": "Levende spillere:",
  "auto.time-421b": "Tid:",
  "auto.wasd-or-joystick-move-0938": "WASD eller joystick – Beveg deg",
  "auto.space-jump-2f3f": "Mellomrom – Hopp",
  "auto.shift-dive-b431": "Shift – Stup",
  "auto.wawa-guys-2e36": "Wawa Guys",
  "auto.change-language-91d6": "Endre språk",
  "auto.accuracy-d78f": "Nøyaktighet",
  "auto.forecasts-46e2": "Prognoser",
  "auto.followers-24c7": "Følgere",
  "auto.win-rate-07a5": "Vinnerrate",
  "auto.verified-analyst-with-confirmed-identity-d570": "Verifisert analytiker med bekreftet identitet",
  "auto.verification-request-under-review-232b": "Verifiseringsforespørsel under vurdering",
  "auto.markdown-supported-9516": "Markdown støttes",
  "auto.nothing-to-preview-a045": "Ingenting å forhåndsvise",
  "auto.analyst-confidence-a744": "Analytikerkonfidens",
  "auto.loading-8524": "Laster...",
  "auto.price-3601": "Pris",
  "auto.ask-about-this-token-a228": "Spør om denne tokenen...",
  "auto.custom-amount-eb30": "Egendefinert beløp",
  "auto.resolved-f691": "Avgjort",
  "auto.correct-d0a3": "Riktig",
  "auto.partial-44ff": "Delvis",
  "auto.incorrect-a94d": "Feil",
  "auto.pending-2d13": "Avventer",
  "auto.no-submissions-yet-7db1": "Ingen bidrag ennå.",
  "auto.ai-judge-f6d9": "AI-dommer:",
  "auto.submissions-are-closed-awaiting-resoluti-0f50": "Stengt for bidrag. Avventer avgjørelse.",
  "auto.your-analysis-bb53": "Din analyse",
  "auto.one-submission-per-event-editable-until-65e5": "Ett bidrag per hendelse. Kan redigeres frem til fristen. Skjult for andre frem til avgjørelse.",
  "auto.your-prediction-037c": "Din prediksjon",
  "auto.reasoning-thesis-a7da": "Begrunnelse / tese",
  "auto.what-do-you-think-will-happen-3a4b": "Hva tror du vil skje?",
  "auto.explain-your-reasoning-cite-sources-or-s-9553": "Forklar begrunnelsen din, oppgi kilder eller signaler...",
  "auto.scoring-983f": "Poengberegning",
  "auto.how-points-work-3888": "Slik fungerer poengene",
  "auto.scoring-rules-will-appear-here-82b7": "Poengregler vil vises her.",
  "auto.top-contributors-52e7": "Toppbidragsytere",
  "auto.full-rankings-466a": "Fullstendig rangering",
  "auto.player-636d": "Spiller",
  "auto.tier-9483": "Nivå",
  "auto.streak-f4bb": "Rekke",
  "auto.score-5dd1": "Poengsum",
  "auto.search-players-827d": "Søk etter spillere…",
  "auto.score-composition-3866": "Poengsammensetning",
  "auto.your-standing-c680": "Din plassering",
  "auto.sign-in-b6d4": "Logg inn",
  "auto.overall-progress-e9d5": "Samlet fremgang",
  "auto.learning-leaderboard-e1fa": "Læringsledertavle",
  "auto.learning-rankings-ef2d": "Læringsrangering",
  "auto.progress-46b5": "Fremgang",
  "auto.out-of-lives-5b83": "Tom for liv!",
  "auto.until-next-life-66cd": "til neste liv",
  "auto.current-hearts-dcdf": "Nåværende hjerter",
  "auto.how-it-works-07cb": "Slik fungerer det:",
  "auto.your-completed-lessons-4475": "Dine fullførte leksjoner",
  "auto.explanation-0bf1": "Forklaring:",
  "auto.trending-3752": "Trender",
  "auto.top-gainers-0413": "Største vinnere",
  "auto.top-losers-d4cc": "Største tapere",
  "auto.recently-added-e1a4": "Nylig lagt til",
  "auto.trend-structure-6f3d": "Trendstruktur",
  "auto.levels-91ae": "Nivåer",
  "auto.cryptos-843d": "Krypto:",
  "auto.market-cap-ff0a": "Markedsverdi:",
  "auto.24h-vol-67f5": "24t volum:",
  "auto.dominance-bc2e": "Dominans:",
  "auto.fear-greed-3bc6": "Frykt og grådighet:",
  "auto.name-49ee": "Navn",
  "auto.market-cap-81c9": "Markedsverdi",
  "auto.circulating-supply-2a56": "Sirkulerende tilbud",
  "auto.last-7-days-4b29": "Siste 7 dager",
  "auto.reset-sort-4673": "Tilbakestill sortering",
  "auto.clear-date-range-2fb4": "Tøm datointervall",
  "auto.remove-source-d074": "Fjern kilde",
  "auto.search-articles-dd17": "Søk i artikler",
  "auto.clear-search-9983": "Tøm søk",
  "auto.sort-articles-83b1": "Sorter artikler",
  "auto.filters-f3f4": "Filtre",
  "auto.refresh-news-322e": "Oppdater nyheter",
  "auto.byteline-2fe0": "Byteline",
  "auto.exit-sphere-mode-dbd1": "Avslutt sfæremodus",
  "auto.type-a-ticker-or-command-eq-nvda-mkt-new-6dda": "Skriv en ticker eller kommando (f.eks. NVDA · mkt · news b · port). Trykk / for å fokusere.",
  "auto.loading-13d4": "laster...",
  "auto.no-coverage-found-acc2": "ingen dekning funnet",
  "auto.loading-wire-3635": "laster nyhetsstrøm...",
  "auto.no-stories-15b2": "ingen saker",
  "auto.last-98bd": "siste",
  "auto.download-episode-15a6": "Last ned episode",
  "auto.add-a-comment-9cf8": "Legg til en kommentar...",
  "auto.stop-playback-d968": "Stopp avspilling",
  "auto.resolving-5e68": "Avklares",
  "auto.sentiment-a0b4": "Sentiment:",
  "auto.key-factors-a050": "Nøkkelfaktorer",
  "auto.total-vol-8020": "Totalt vol.",
  "auto.24h-vol-0d59": "24t-vol.",
  "auto.liquidity-ced4": "Likviditet",
  "auto.set-price-alert-24fa": "Sett prisvarsel",
  "auto.no-market-data-available-32ee": "Ingen markedsdata tilgjengelig",
  "auto.ai-top-pick-201e": "AIs toppvalg",
  "auto.ai-recommendation-6522": "AI-anbefaling",
  "auto.outcome-cf73": "Utfall",
  "auto.chance-332f": "% sjanse",
  "auto.ai-pick-dcd1": "AI-valg",
  "auto.trade-5f39": "Handle",
  "auto.select-outcome-2799": "Velg utfall",
  "auto.alert-when-price-goes-7231": "Varsle når prisen går",
  "auto.target-price-8689": "Målpris (%)",
  "auto.bull-case-2541": "Bull-case",
  "auto.bear-case-c063": "Bear-case",
  "auto.risks-d179": "Risikoer",
  "auto.no-live-arbitrage-opportunities-a3dc": "Ingen aktive arbitrasjemuligheter.",
  "auto.regenerate-b232": "Generer på nytt",
  "auto.no-digest-yet-click-regenerate-d188": "Ingen sammendrag ennå. Klikk Generer på nytt.",
  "auto.top-arbs-3030": "Beste arbs",
  "auto.whale-moves-3d39": "Hvalbevegelser",
  "auto.probability-shifts-4de8": "Sannsynlighetsendringer",
  "auto.kalshi-a929": "Kalshi",
  "auto.polymarket-0fa9": "Polymarket",
  "auto.top-of-book-8930": "Topp av ordrebok",
  "auto.orderbook-112f": "Ordrebok",
  "auto.trades-18da": "Handler",
  "auto.enter-a-market-id-and-click-fetch-149d": "Skriv inn en market_id og klikk Hent.",
  "auto.market-id-af0e": "market_id",
  "auto.crypto-79ad": "Krypto",
  "auto.macro-4374": "Makro",
  "auto.waiting-for-messages-relay-session-lasts-f6a4": "Venter på meldinger... (reléøkten varer ~50s, koble til på nytt ved å klikke igjen)",
  "auto.tap-to-view-markets-7ece": "Trykk for å se markeder.",
  "auto.ask-anything-4686": "Spør om hva som helst...",
  "auto.order-ticket-0daa": "Ordreseddel",
  "auto.limit-price-49cc": "Grensepris (¢)",
  "auto.shares-d272": "Andeler",
  "auto.confirm-your-order-2d1b": "Bekreft ordren",
  "auto.cancel-ea47": "Avbryt",
  "auto.select-an-outcome-9933": "Velg et utfall",
  "auto.trading-with-real-money-carries-real-ris-acf0": "Handel med ekte penger innebærer reell risiko.",
  "auto.eligibility-fb28": "Kvalifisering:",
  "auto.how-your-credentials-are-handled-e38d": "Hvordan innloggingsopplysningene dine håndteres",
  "auto.disconnecting-a-venue-deletes-the-stored-3f3f": "Frakobling av et handelssted sletter de lagrede opplysningene umiddelbart.",
  "auto.connect-kalshi-d258": "Koble til Kalshi",
  "auto.api-key-id-6452": "API-nøkkel-ID",
  "auto.rsa-private-key-pem-b5cb": "RSA privat nøkkel (PEM)",
  "auto.connect-polymarket-d376": "Koble til Polymarket",
  "auto.polygon-private-key-afbf": "Polygon privat nøkkel",
  "auto.track-events-to-see-whale-trades-here-7591": "Følg hendelser for å se hvalhandler her.",
  "auto.interpret-ad79": "Tolk",
  "auto.click-interpret-to-classify-recent-whale-7e9f": "Klikk på Tolk for å klassifisere nylige hvalhandler.",
  "auto.go-premium-68e1": "Bli Premium",
  "auto.refer-amp-earn-88de": "Verv &amp; tjen",
  "auto.sign-in-to-get-your-link-3a83": "Logg inn for å få lenken din",
  "auto.your-referral-link-9360": "Din vervelenke",
  "auto.copy-referral-link-b233": "Kopier vervelenke",
  "auto.invited-aa34": "Invitert",
  "auto.subscribed-808c": "Abonnert",
  "auto.earned-0c19": "Opptjent",
  "auto.0x-erc-20-or-t-trc-20-8ec0": "0x… (ERC-20) eller T… (TRC-20)",
  "auto.search-tools-e30f": "Søk i verktøy...",
  "auto.custom-colour-ead5": "Egendefinert farge",
  "auto.custom-body-colour-a281": "Egendefinert kroppsfarge",
  "auto.owned-avatar-2136": "Eid avatar",
  "auto.delete-avatar-66e0": "Slett avatar",
  "auto.enter-your-display-name-c3d9": "Skriv inn visningsnavnet ditt",
  "auto.enter-your-username-dd62": "Skriv inn brukernavnet ditt",
  "auto.tell-us-about-yourself-490b": "Fortell om deg selv...",
  "auto.streak-d832": "rekke",
  "auto.what-s-on-your-mind-4a31": "Hva tenker du på?",
  "auto.edit-avatar-5dcd": "Rediger avatar",
  "auto.edit-profile-dfd8": "Rediger profil",
  "auto.supports-jpg-png-max-10mb-6dac": "Støtter JPG, PNG (maks 10 MB)",
  "auto.uploaded-fe8d": "Lastet opp",
  "auto.generated-avatar-f8c8": "Generert avatar",
  "auto.previous-post-bc9d": "Forrige innlegg",
  "auto.next-post-ebd8": "Neste innlegg",
  "auto.play-the-next-video-automatically-7ca8": "Spill av neste video automatisk",
  "auto.play-this-video-a220": "Spill av denne videoen",
  "auto.resume-video-3494": "Gjenoppta video",
  "auto.open-comments-b1b9": "Åpne kommentarer",
  "auto.about-this-post-3fd2": "Om dette innlegget",
  "auto.loading-videos-719c": "Laster videoer",
  "auto.add-a-comment-c3ed": "Legg til en kommentar",
  "auto.delete-comment-547f": "Slett kommentar",
  "auto.share-this-issue-c878": "Del denne utgaven",
  "auto.fear-amp-greed-6b78": "Frykt &amp; grådighet",
  "auto.try-again-d876": "Prøv igjen",
  "auto.this-story-couldn-t-be-loaded-in-full-he-2027": "Denne saken kunne ikke lastes i sin helhet her. Du kan lese den hos den opprinnelige kilden.",
  "auto.press-release-5027": "Pressemelding",
  "auto.back-0557": "Tilbake",
  "auto.practice-completed-lessons-to-restore-yo-9210": "Øv på fullførte leksjoner for å gjenopprette hjertene dine!",
  "auto.practice-now-8cfb": "Øv nå",
  "auto.back-to-podcast-b4fe": "Tilbake til podkasten",
  "auto.related-news-1e3a": "Relaterte nyheter",
  "auto.back-to-games-e1a4": "Tilbake til spill",
  "auto.performance-over-time-00a3": "Utvikling over tid",
  "auto.investment-thesis-d260": "Investeringstese",
  "auto.live-f35d": "DIREKTE",
  "auto.ai-powered-polymarket-prediction-trackin-5a1d": "AI-drevet sporing av Polymarket-prediksjoner",
  "auto.refresh-63a6": "Oppdater",
  "auto.active-markets-6ab2": "Aktive markeder",
  "auto.ai-predictions-2a62": "AI-prediksjoner",
  "auto.top-pick-742c": "Toppvalg",
  "auto.no-consensus-picks-available-yet-run-ai-6b0c": "Ingen konsensusvalg tilgjengelig ennå. Kjør AI-analyse for å generere prediksjoner.",
  "auto.advanced-search-cd4e": "Avansert søk",
  "auto.website-15bb": "Nettsted",
  "auto.no-episodes-available-yet-794e": "Ingen episoder tilgjengelig ennå",
  "auto.back-to-markets-51bb": "Tilbake til markeder",
  "auto.trade-on-polymarket-c80a": "Handle på Polymarket",
  "auto.you-need-to-be-signed-in-to-view-your-pr-3611": "Du må være logget inn for å se profilen din og dele tankene dine.",
  "auto.the-token-you-re-looking-for-doesn-t-exi-2418": "Tokenet du leter etter eksisterer ikke eller har blitt fjernet.",
  "auto.whitepaper-bb56": "Whitepaper",
  "auto.github-d3b7": "GitHub",
  "auto.you-need-to-be-logged-in-to-bookmark-art-a40d": "Du må være logget inn for å bokmerke artikler og se det lagrede innholdet ditt.",
  "auto.you-haven-t-bookmarked-any-articles-yet-0cef": "Du har ikke bokmerket noen artikler ennå. Begynn å lese og bokmerk de du liker.",
  "auto.sign-in-to-see-your-activity-feed-includ-752b": "Logg inn for å se aktivitetsstrømmen din, inkludert innleggene dine, kommentarer og mer.",
  "auto.create-a-new-room-or-join-an-existing-on-6fde": "Opprett et nytt rom eller bli med i et eksisterende",
  "auto.create-a-new-room-and-invite-your-friend-9557": "Opprett et nytt rom og inviter vennene dine til å bli med ved hjelp av romkoden.",
  "auto.please-sign-in-to-create-a-room-0398": "Vennligst logg inn for å opprette et rom",
  "auto.enter-the-6-character-room-code-shared-b-b044": "Skriv inn romkoden på 6 tegn som du fikk fra vennen din.",
  "auto.join-a286": "Bli med",
  "auto.please-sign-in-to-join-a-room-cc52": "Vennligst logg inn for å bli med i et rom",
  "auto.start-a-room-or-join-with-a-code-fde0": "Start et rom eller bli med med en kode",
  "auto.share-the-code-with-friends-dea4": "Del koden med venner",
  "auto.be-first-to-reach-the-finish-d35c": "Vær den første til å nå mål",
  "auto.play-de3c": "Spill",
  "auto.get-started-e0c4": "Kom i gang",
  "auto.every-forecast-is-tracked-and-verified-s-df73": "Hver prognose spores og verifiseres. Se reell treffsikkerhet, ikke bare påstander.",
  "auto.no-gambling-analysts-are-paid-for-resear-096d": "Ingen gambling. Analytikere får betalt for analysekvalitet, ikke veddemål.",
  "auto.get-ai-powered-insights-from-news-and-po-c1f4": "Få AI-drevet innsikt fra nyheter og podkaster når du lager prognoser.",
  "auto.be-the-first-to-create-an-analyst-profil-39d9": "Bli den første til å opprette en analytikerprofil!",
  "auto.be-the-first-to-join-the-intelligence-pr-e035": "Bli den første til å bli med i Intelligence Pro-fellesskapet",
  "auto.you-already-have-an-analyst-profile-visi-2934": "Du har allerede en analytikerprofil. Gå til dashbordet ditt for å administrere prognosene og innleggene dine.",
  "auto.view-profile-ccd9": "Vis profil",
  "auto.verify-that-you-meet-the-requirements-to-c3d5": "Bekreft at du oppfyller kravene for å bli analytiker",
  "auto.subscribe-to-intelligence-pro-4161": "Abonner på Intelligence Pro",
  "auto.continue-a0bf": "Fortsett",
  "auto.set-up-your-analyst-identity-3e9c": "Sett opp din analytikeridentitet",
  "auto.help-others-understand-your-expertise-819a": "Hjelp andre med å forstå din ekspertise",
  "auto.review-your-profile-before-submitting-0b1a": "Se over profilen din før du sender inn",
  "auto.i-agree-to-the-terms-of-service-and-unde-ab09": "Jeg godtar brukervilkårene og forstår at prognosene mine vil bli sporet offentlig for treffsikkerhet",
  "auto.secure-payments-d4df": "Sikre betalinger",
  "auto.achievements-f5c7": "Prestasjoner",
  "auto.sync-d8e8": "Synkroniser",
  "auto.ending-soon-19b1": "Avsluttes snart",
  "auto.newest-ac71": "Nyeste",
  "auto.retry-6327": "Prøv igjen",
  "auto.nothing-tracked-yet-use-the-star-icon-on-723c": "Ingenting sporet ennå, bruk stjerneikonet på en hendelse.",
  "auto.cross-venue-analysis-and-market-research-18fe": "Analyser på tvers av plattformer og markedsanalyse på forespørsel. Spør om hva som helst om aktive markeder.",
  "auto.open-copilot-d576": "Åpne Copilot",
  "auto.update-your-payment-method-or-cancel-any-7f97": "Oppdater betalingsmetoden din eller avslutt når som helst.",
  "auto.secure-checkout-by-stripe-cancel-any-tim-0265": "Sikker betaling med Stripe. Avslutt når som helst.",
  "auto.try-again-f915": "Prøv igjen",
  "auto.previous-dd1f": "Forrige",
  "auto.next-10ac": "Neste",
  "auto.loading-articles-cache-dc6d": "Laster inn hurtigbuffer for artikler...",
  "auto.posts-from-the-creators-we-follow-will-a-c4e8": "Innlegg fra skaperne vi følger, vil vises her så snart de samles inn.",
  "auto.read-the-guide-ef42": "Les guiden",
  "auto.let-ai-assistants-work-directly-with-byt-7497": "La AI-assistenter jobbe direkte med Byteline-saker, daglige oppsummeringer, ukentlige sammendrag og markedsdata.",
  "auto.ai-article-analysis-d396": "AI-artikkelanalyse",
  "auto.related-prediction-markets-0177": "Relaterte prediksjonsmarkeder",
  "auto.ai-analysis-8fd8": "AI-analyse",
  "auto.generating-ai-powered-analysis-56c6": "Genererer AI-drevet analyse...",
  "auto.add-a-message-optional-1896": "Legg til en melding (valgfritt)",
  "auto.share-with-f27e": "Del med",
  "auto.forgot-password-8458": "Glemt passord?",
  "auto.password-must-be-at-least-8-characters-l-db06": "Passordet må være på minst 8 tegn",
  "auto.terms-of-service-3b6c": "Vilkår for bruk",
  "auto.privacy-policy-fa2e": "Personvernerklæring",
  "auto.this-page-is-available-to-byteline-membe-6f22": "Denne siden er tilgjengelig for Byteline-medlemmer.",
  "auto.sign-in-or-create-an-account-7b9d": "Logg inn eller opprett en konto",
  "auto.profile-cce9": "Profil",
  "auto.bookmarks-7a69": "Bokmerker",
  "auto.your-comment-on-this-story-514b": "Din kommentar til denne saken",
  "auto.get-ai-analysis-1f35": "Få AI-analyse",
  "auto.no-chart-data-available-8de1": "Ingen diagramdata tilgjengelig",
  "auto.daily-audio-recap-e3f1": "Daglig lydsammendrag",
  "auto.your-browser-does-not-support-the-audio-cd02": "Nettleseren din støtter ikke lydelementet.",
  "auto.daily-tech-recap-f2ce": "Daglig tech-oppsummering",
  "auto.today-s-tech-news-d448": "Dagens tech-nyheter",
  "auto.top-movers-today-34ee": "Største bevegelser i dag",
  "auto.auto-play-next-recap-291d": "Spill av neste sammendrag automatisk",
  "auto.unable-to-load-market-data-9492": "Kunne ikke laste markedsdata",
  "auto.when-people-share-articles-with-you-they-a0de": "Når noen deler artikler med deg, vises de her",
  "auto.what-s-happening-ee6c": "Hva skjer",
  "auto.who-to-follow-ef20": "Hvem du bør følge",
  "auto.follow-3903": "Følg",
  "auto.leave-game-063e": "Forlat spillet",
  "auto.battle-royale-last-one-standing-wins-7811": "Battle Royale – Siste som står igjen vinner!",
  "auto.invite-players-4736": "Inviter spillere",
  "auto.start-game-1b07": "Start spillet",
  "auto.waiting-for-host-to-start-2034": "Venter på at verten skal starte...",
  "auto.go-back-4f2f": "Gå tilbake",
  "auto.no-articles-found-the-sync-process-is-ru-96a0": "Ingen artikler funnet. Synkroniseringen kjører i bakgrunnen for å hente de nyeste nyhetene.",
  "auto.no-articles-match-your-current-filters-t-d861": "Ingen artikler passer med de valgte filtrene. Prøv å endre søket eller filterkriteriene.",
  "auto.we-aggregate-reporting-from-leading-tech-a89f": "Vi samler saker fra ledende publikasjoner innen teknologi, næringsliv og finans for å gi deg en helhetlig dekning.",
  "auto.market-trends-b918": "Markedstrender",
  "auto.view-all-tokens-d773": "Se alle tokens",
  "auto.long-8394": "Long",
  "auto.short-30bb": "Short",
  "auto.no-performance-data-available-yet-a345": "Ingen ytelsesdata tilgjengelig ennå",
  "auto.most-popular-425e": "Mest populære",
  "auto.trending-forecasts-5f36": "Populære prognoser",
  "auto.no-trending-forecasts-yet-5935": "Ingen populære prognoser ennå",
  "auto.edit-7dce": "Rediger",
  "auto.preview-31fd": "Forhåndsvisning",
  "auto.profile-completion-7b03": "Profilfullføring",
  "auto.research-co-pilot-2eeb": "Research-copilot",
  "auto.show-your-appreciation-for-great-insight-be3b": "Vis at du setter pris på god innsikt",
  "auto.navigation-8464": "Navigasjon",
  "auto.home-8cf0": "Hjem",
  "auto.news-dd1b": "Nyheter",
  "auto.tokens-f686": "Tokens",
  "auto.resources-ddcf": "Ressurser",
  "auto.about-8f7f": "Om",
  "auto.editorial-standards-bee2": "Redaksjonelle standarder",
  "auto.contact-bbaf": "Kontakt",
  "auto.privacy-c5f2": "Personvern",
  "auto.terms-6f1b": "Vilkår",
  "auto.cookies-597b": "Informasjonskapsler",
  "auto.no-rankings-yet-be-the-first-1539": "Ingen rangeringer ennå, bli den første.",
  "auto.no-players-match-your-search-b9a7": "Ingen spillere samsvarer med søket ditt.",
  "auto.sign-in-to-track-your-rank-streak-and-ti-982a": "Logg inn for å spore rangering, rekke og nivåfremgang.",
  "auto.earn-your-first-xp-to-appear-on-the-lead-136e": "Tjen din første XP for å vises på ledertavlen. Les en artikkel eller fullfør en leksjon for å komme i gang.",
  "auto.jump-here-bf88": "HOPP HIT?",
  "auto.learning-achievements-2068": "Læringsprestasjoner",
  "auto.track-your-learning-progress-and-unlock-7404": "Følg læringsfremgangen din og lås opp prestasjoner",
  "auto.lessons-completed-6fe3": "Fullførte leksjoner",
  "auto.learning-streak-bfb0": "Læringsrekke",
  "auto.completion-2fea": "Fullføring",
  "auto.take-a-break-your-lives-will-regenerate-66b8": "Ta en pause! Livene dine vil regenereres over tid, eller du kan øve for å gjenopprette dem.",
  "auto.practice-to-restore-hearts-4a1c": "Øv for å gjenopprette hjerter",
  "auto.wait-for-lives-7577": "Vent på liv",
  "auto.complete-some-lessons-first-to-unlock-pr-5588": "Fullfør noen leksjoner først for å låse opp øvingsmodus!",
  "auto.review-and-earn-1-heart-291d": "Repeter og tjen 1 hjerte",
  "auto.practice-8c00": "Øv",
  "auto.check-060b": "Sjekk",
  "auto.show-more-146f": "Vis mer",
  "auto.load-more-articles-eb53": "Last inn flere artikler",
  "auto.clear-all-81aa": "Fjern alt",
  "auto.sources-fb61": "Kilder",
  "auto.reset-526d": "Tilbakestill",
  "auto.reset-all-09a5": "Tilbakestill alt",
  "auto.loading-quotes-b905": "laster inn kurser...",
  "auto.price-trace-8313": "prisspor",
  "auto.related-headlines-5c77": "relaterte overskrifter",
  "auto.sell-8325": "selg",
  "auto.reset-8626": "nullstill",
  "auto.no-open-positions-644a": "ingen åpne posisjoner",
  "auto.no-comments-yet-be-the-first-to-comment-7ef4": "Ingen kommentarer ennå. Bli den første til å kommentere!",
  "auto.episode-description-d2d4": "Episodebeskrivelse",
  "auto.view-episode-5504": "Se episode",
  "auto.stop-close-b6ae": "Stopp og lukk",
  "auto.ai-market-analysis-4df3": "AI-markedsanalyse",
  "auto.generate-ai-analysis-0114": "Generer AI-analyse",
  "auto.this-analysis-is-over-24-hours-old-consi-ec74": "Denne analysen er over 24 timer gammel. Vurder å generere på nytt for oppdaterte data.",
  "auto.related-news-83c2": "Relaterte nyheter",
  "auto.from-byteline-8469": "fra Byteline",
  "auto.no-related-news-found-f4e9": "Ingen relaterte nyheter funnet",
  "auto.set-price-alert-cea7": "Sett prisvarsel",
  "auto.above-5b46": "Over",
  "auto.below-e59d": "Under",
  "auto.run-an-ai-analysis-combining-outcomes-oh-0fb8": "Kjør en AI-analyse som kombinerer utfall, OHLCV og hvalaktivitet.",
  "auto.no-tradable-outcomes-on-this-event-yet-68d3": "Ingen omsettelige utfall på denne hendelsen ennå.",
  "auto.this-sends-a-real-order-with-real-money-355f": "Dette sender en reell ordre med ekte penger og kan ikke angres fra Byteline.",
  "auto.place-order-e796": "Legg inn ordre",
  "auto.sign-in-to-connect-a-trading-account-75f2": "Logg inn for å koble til en handelskonto.",
  "auto.no-whale-trades-yet-track-an-event-from-7350": "Ingen hvalhandler ennå. Følg en hendelse fra Markeder-fanen.",
  "auto.premium-content-fd6f": "Premium-innhold",
  "auto.unlock-premium-cf87": "Lås opp Premium",
  "auto.secure-checkout-via-stripe-cancel-anytim-702b": "Sikker betaling via Stripe. Kanseller når som helst.",
  "auto.you-will-be-redirected-to-stripe-to-comp-5491": "Du blir omdirigert til Stripe for å fullføre abonnementet.",
  "auto.no-referrals-yet-share-your-link-to-get-af23": "Ingen vervinger ennå, del lenken din for å komme i gang.",
  "auto.unlocked-298a": "LÅST OPP",
  "auto.no-activity-yet-start-by-creating-a-post-5295": "Ingen aktivitet ennå. Start med å opprette et innlegg eller kommentere artikler!",
  "auto.customize-avatar-36dd": "Tilpass avatar",
  "auto.avatar-builder-b522": "Avatarbygger",
  "auto.done-f929": "Ferdig",
  "auto.badge-unlocked-b911": "Merke låst opp!",
  "auto.keep-up-the-amazing-work-and-unlock-more-0f90": "Fortsett det gode arbeidet og lås opp flere merker!",
  "auto.awesome-125a": "Fantastisk!",
  "auto.save-c9cc": "Lagre",
  "auto.download-801a": "Last ned",
  "auto.celebrated-c46f": "FEIRET",
  "auto.check-back-later-for-today-s-tech-news-r-4179": "Kom tilbake senere for dagens teknologinyheter",
  "auto.completed-07ca": "Fullført",
  "auto.earn-10-xp-90c0": "Tjen 10 XP",
  "auto.following-6f79": "Følger",
  "auto.you-re-not-following-anyone-yet-b2cb": "Du følger ingen ennå",
  "auto.unfollow-3596": "Slutt å følge",
  "auto.no-followers-yet-675a": "Ingen følgere ennå",
  "auto.week-1-9de8": "UKE 1",
  "auto.view-plans-0bfd": "Se planer",
  "auto.active-4d3d": "Aktiv",
  "auto.today-s-challenges-cbf1": "Dagens utfordringer",
  "auto.no-challenges-assigned-yet-check-back-to-d7e8": "Ingen utfordringer tildelt ennå. Sjekk igjen i morgen!",
  "auto.your-monthly-badges-a889": "Dine månedlige merker",
  "auto.edit-profile-1860": "Rediger profil",
  "auto.browse-tools-0a7a": "Utforsk verktøy",
  "auto.add-tools-81fb": "Legg til verktøy",
  "auto.add-tokens-to-your-watchlist-to-track-th-eaca": "Legg til tokens i overvåkningslisten din for å følge utviklingen her.",
  "auto.add-tokens-e701": "Legg til tokens",
  "auto.add-token-550f": "Legg til token",
  "auto.edit-avatar-b497": "Rediger avatar",
  "auto.crypto-enthusiast-4c52": "Kryptoentusiast",
  "auto.change-photo-80de": "Endre bilde",
  "auto.browse-files-6b19": "Bla gjennom filer",
  "auto.generating-avatar-27b5": "Genererer avatar...",
  "auto.generate-avatar-c695": "Generer avatar",
  "auto.creating-your-pixel-art-avatar-this-may-380d": "Lager din pikselkunst-avatar... Dette kan ta 10–20 sekunder.",
  "auto.generate-again-3de1": "Generer på nytt",
  "auto.added-f29d": "Lagt til",
  "auto.saving-575f": "Lagrer...",
  "auto.your-post-262c": "Ditt innlegg",
  "auto.posting-2d82": "Publiserer...",
  "auto.recent-searches-5c79": "Nylige søk",
  "auto.clear-dc30": "Tøm",
  "auto.suggestions-41ec": "Forslag",
  "auto.your-comment-on-this-video-0b0a": "Din kommentar til denne videoen",
  "auto.sign-in-to-comment-60a6": "Logg inn for å kommentere",
  "auto.further-reading-1ba5": "Videre lesning",
  "auto.all-podcasts-d5fb": "Alle podkaster",
  "auto.weekly-performance-c408": "Ukentlig resultat",
  "auto.market-data-was-unavailable-when-this-is-52ba": "Markedsdata var ikke tilgjengelig da denne utgaven ble generert.",
  "auto.an-error-occurred-while-loading-this-pag-5668": "Det oppstod en feil under lasting av denne siden. Vennligst prøv igjen.",
};

export const zhHantAuto: Partial<Record<keyof typeof enAuto, string>> = {
  "auto.analyzing-article-sentiment": "\u6b63\u5728\u5206\u6790\u6587\u7ae0\u60c5\u7dd2\u2026",
  "auto.share-article-a4bd": "分享文章",
  "auto.you-re-not-following-anyone-yet-04bb": "你尚未追蹤任何人",
  "auto.follow-people-to-share-articles-with-the-2376": "追蹤他人以分享文章",
  "auto.please-sign-in-to-join-the-discussion-5b52": "請登入以參與討論",
  "auto.no-comments-yet-be-the-first-to-share-yo-849d": "尚無留言。搶先分享你的想法！",
  "auto.price-3e82": "價格",
  "auto.market-cap-690d": "市值",
  "auto.fdv-488b": "FDV",
  "auto.circulating-supply-fea1": "流通供應量",
  "auto.ai-analysis-e639": "AI 分析",
  "auto.markets-c3c4": "市場",
  "auto.latest-news-4e11": "最新新聞",
  "auto.no-recent-news-available-c6d3": "暫無最新消息",
  "auto.no-recent-news-found-3e77": "找不到近期新聞",
  "auto.loading-chart-data-8bde": "正在載入圖表資料...",
  "auto.searching-ba2b": "搜尋中...",
  "auto.name-709a": "名稱",
  "auto.market-cap-d553": "市值",
  "auto.actions-c3cd": "操作",
  "auto.today-s-recap-will-be-available-soon-b12e": "今日回顧即將推出",
  "auto.check-back-later-for-the-daily-summary-2ce9": "請稍後回來查看每日摘要",
  "auto.no-articles-published-today-yet-e14c": "今天尚未發布任何文章",
  "auto.no-data-available-0cfc": "暫無資料",
  "auto.biggest-gainers-in-the-last-24-hours-b83d": "過去 24 小時漲幅榜",
  "auto.24h-volume-9aeb": "24 小時交易量",
  "auto.btc-dominance-8a7c": "BTC 市佔率",
  "auto.active-cryptocurrencies-7399": "活躍加密貨幣",
  "auto.updated-5-min-ago-9c8f": "5 分鐘前更新",
  "auto.ai-briefing-is-unavailable-right-now-b56b": "AI 簡報目前無法使用。",
  "auto.loading-33ce": "載入中…",
  "auto.live-65c8": "即時",
  "auto.loading-live-markets-f335": "正在載入即時市場…",
  "auto.sort-adc4": "排序",
  "auto.no-sources-available-yet-59f8": "尚無可用來源。",
  "auto.sign-in-to-leave-a-comment-e697": "登入以發表留言",
  "auto.achievements-a663": "成就",
  "auto.reward-c7d7": "獎勵",
  "auto.your-activity-7540": "你的動態",
  "auto.browse-web3-tools-dapps-1c3b": "瀏覽 Web3 工具與 DApp",
  "auto.crypto-enthusiast-2e1a": "加密貨幣愛好者",
  "auto.skin-tone-6375": "膚色",
  "auto.body-style-9e5b": "身形風格",
  "auto.avatar-studio-25ae": "頭像工作室",
  "auto.character-ee99": "角色",
  "auto.body-colour-176d": "身體顏色",
  "auto.cached-colours-are-free-xp-is-charged-on-3941": "快取的顏色免費。僅在 Nano Banana 3 建立新顏色時扣除 XP。",
  "auto.background-64dd": "背景",
  "auto.your-collection-f01e": "你的收藏",
  "auto.delete-this-avatar-fabf": "要刪除此頭像嗎？",
  "auto.cancel-77df": "取消",
  "auto.hair-style-fd9c": "髮型",
  "auto.eye-color-68a3": "眼睛顏色",
  "auto.accessories-f3b5": "配件",
  "auto.facial-hair-c8d1": "鬍鬚",
  "auto.no-recent-celebrations-a3a5": "近期無慶祝動態",
  "auto.commented-on-article-bf0a": "在文章中留言",
  "auto.loading-recaps-5b84": "正在載入回顧...",
  "auto.no-daily-recap-available-yet-13c7": "尚無每日回顧",
  "auto.daily-recap-queue-96b8": "每日回顧佇列",
  "auto.today-s-recap-a23d": "今日回顧",
  "auto.today-s-daily-recap-4864": "今日每日摘要",
  "auto.new-eee2": "最新！",
  "auto.daily-recap-b0b4": "每日摘要",
  "auto.edit-profile-cd28": "編輯個人檔案",
  "auto.display-name-8d6b": "顯示名稱",
  "auto.username-84c2": "使用者名稱",
  "auto.bio-b31f": "個人簡介",
  "auto.statistics-2086": "統計數據",
  "auto.no-profile-data-available-07b3": "尚無個人檔案資料",
  "auto.day-streak-350f": "連續天數",
  "auto.total-xp-de22": "總 XP",
  "auto.current-league-4376": "目前聯賽",
  "auto.your-benefits-03dd": "您的權益：",
  "auto.view-forecasts-a04d": "查看預測",
  "auto.browse-analyst-predictions-7c40": "瀏覽分析師預測",
  "auto.create-content-dfb9": "建立內容",
  "auto.publish-forecasts-analysis-4da4": "發布預測與分析",
  "auto.commented-on-a-podcast-episode-29be": "評論了 Podcast 單集",
  "auto.share-your-thoughts-af96": "分享您的想法",
  "auto.following-90ee": "追蹤中",
  "auto.followers-78ea": "追蹤者",
  "auto.edit-avatar-4ea4": "編輯頭像",
  "auto.your-stats-427c": "您的數據",
  "auto.points-4b2a": "積分",
  "auto.day-streak-ca4b": "連續天數",
  "auto.league-7096": "聯賽",
  "auto.earn-points-a33f": "賺取積分",
  "auto.read-an-article-79a7": "閱讀文章",
  "auto.5-pts-ef93": "+5 積分",
  "auto.comment-on-article-378d": "評論文章",
  "auto.10-pts-3247": "+10 積分",
  "auto.create-a-post-8421": "發布貼文",
  "auto.15-pts-1cca": "+15 積分",
  "auto.browse-pages-eb8e": "瀏覽頁面",
  "auto.1-pt-4a3f": "+1 積分",
  "auto.wall-c463": "動態牆",
  "auto.watchlist-48a6": "追蹤清單",
  "auto.tools-4fa8": "工具",
  "auto.web3-tools-dapps-288d": "Web3 工具與 DApps",
  "auto.no-web3-tools-added-yet-a318": "尚未新增 Web3 工具",
  "auto.no-tokens-in-watchlist-0783": "追蹤清單中尚無代幣",
  "auto.your-watchlist-ba90": "您的追蹤清單",
  "auto.ai-avatar-generator-4e96": "AI 頭像生成器",
  "auto.upload-your-photo-3a43": "上傳您的照片",
  "auto.drop-your-photo-here-or-56ec": "將照片拖曳至此，或",
  "auto.your-generated-avatar-177c": "您生成的頭像",
  "auto.filters-96e5": "篩選",
  "auto.date-range-6bb4": "日期範圍",
  "auto.sources-2eb5": "來源",
  "auto.categories-6ccb": "分類",
  "auto.loading-suggestions-7645": "正在載入建議...",
  "auto.this-one-cannot-be-played-here-c71c": "此內容無法在此播放。",
  "auto.tap-for-sound-a80b": "輕點開啟聲音",
  "auto.comments-fce0": "留言",
  "auto.about-6b21": "關於",
  "auto.no-comments-yet-207b": "尚無留言。",
  "auto.quick-quiz-648f": "快速測驗",
  "auto.editor-s-note-ffa0": "編者按",
  "auto.past-issues-6510": "過往期數",
  "auto.market-pulse-ff2f": "市場脈動",
  "auto.crypto-e849": "加密貨幣",
  "auto.narrative-of-the-week-60f4": "本週焦點趨勢",
  "auto.top-stories-1fa6": "頭條新聞",
  "auto.listen-this-week-dda7": "本週收聽",
  "auto.movers-7-day-5599": "7 日漲跌排行",
  "auto.winners-1d50": "漲幅榜",
  "auto.losers-6ce7": "跌幅榜",
  "auto.what-we-publish-c716": "發布內容",
  "auto.daily-recap-of-the-stories-that-moved-th-d0dc": "每日回顧推動產業發展的焦點事件。",
  "auto.weekly-brief-with-the-themes-behind-the-951f": "每週簡報，深入解析頭條背後的趨勢脈絡。",
  "auto.market-pages-for-crypto-assets-and-techn-2777": "加密資產與科技股的行情專頁。",
  "auto.topic-guides-explaining-recurring-subjec-abfd": "以淺顯易懂的語言解析常態主題的專題指南。",
  "auto.ownership-and-funding-be43": "所有權與資金來源",
  "auto.contact-b374": "聯絡我們",
  "auto.article-not-found-39d5": "找不到文章",
  "auto.return-to-home-7d70": "返回首頁",
  "auto.admin-panel-9371": "管理後台",
  "auto.this-article-has-been-translated-677d": "此文章已翻譯",
  "auto.related-articles-cfd2": "相關文章",
  "auto.source-6da1": "來源",
  "auto.no-recent-stories-for-this-writer-e862": "此作者近期無新報導。",
  "auto.login-to-view-bookmarks-cec4": "登入以查看收藏",
  "auto.login-4e5a": "登入",
  "auto.no-bookmarks-yet-aaf8": "尚無收藏",
  "auto.browse-articles-6cc4": "瀏覽文章",
  "auto.no-lessons-available-yet-f1e3": "目前尚無可用課程",
  "auto.need-hearts-bfc9": "需要愛心？",
  "auto.your-progress-9839": "你的進度",
  "auto.completion-2ff2": "完成度",
  "auto.streak-ac47": "連續天數",
  "auto.sourcing-and-credit-1c70": "來源與引用",
  "auto.use-of-artificial-intelligence-0101": "人工智慧使用原則",
  "auto.verification-0312": "事實查核",
  "auto.corrections-ccc7": "更正聲明",
  "auto.independence-1db5": "獨立性聲明",
  "auto.episode-not-found-8ce5": "找不到單集",
  "auto.show-notes-5699": "節目資訊",
  "auto.your-feed-awaits-8973": "專屬動態已備妥",
  "auto.sign-in-f849": "登入",
  "auto.for-you-7e13": "為你推薦",
  "auto.shared-with-you-72f2": "與你分享",
  "auto.start-playing-54ff": "開始遊戲",
  "auto.create-room-7a91": "建立房間",
  "auto.join-room-902f": "加入房間",
  "auto.how-to-play-9686": "遊戲玩法",
  "auto.create-or-join-cf74": "建立或加入",
  "auto.wait-for-players-2b50": "等待玩家",
  "auto.race-to-win-fcd6": "爭奪第一！",
  "auto.game-not-found-e875": "找不到遊戲",
  "auto.room-d295": "房間：",
  "auto.loading-game-0a6b": "正在載入遊戲...",
  "auto.games-398e": "遊戲",
  "auto.max-players-77c3": "人數上限",
  "auto.win-xp-ff81": "贏得 XP",
  "auto.subscribe-now-378b": "立即訂閱",
  "auto.browse-forecasts-2c04": "瀏覽預測",
  "auto.why-intelligence-pro-2b11": "為何選擇 Intelligence Pro？",
  "auto.verified-track-records-82ee": "經驗證的歷史績效",
  "auto.halal-compliant-1ba3": "符合清真規範",
  "auto.ai-research-co-pilot-82f3": "AI 研究助手",
  "auto.top-analysts-4304": "頂尖分析師",
  "auto.view-all-931e": "查看全部",
  "auto.recent-forecasts-ea5d": "近期預測",
  "auto.analyst-not-found-2f77": "找不到分析師",
  "auto.back-to-analysts-7e2c": "返回分析師列表",
  "auto.analyst-profile-502b": "分析師檔案",
  "auto.total-forecasts-7645": "總預測數",
  "auto.win-rate-49a3": "勝率",
  "auto.brier-score-fa35": "Brier 分數",
  "auto.theses-0164": "投資論點",
  "auto.playbooks-01e7": "策略手冊",
  "auto.post-mortems-75ec": "覆盤分析",
  "auto.no-forecasts-yet-c7f3": "尚無預測",
  "auto.no-theses-yet-9967": "尚無論點",
  "auto.no-playbooks-yet-315b": "尚無策略手冊",
  "auto.no-post-mortems-yet-0e17": "尚無覆盤分析",
  "auto.active-analysts-f8dd": "活躍分析師",
  "auto.avg-accuracy-a5a5": "平均準確率",
  "auto.total-followers-4db2": "總追蹤人數",
  "auto.no-analysts-yet-d76d": "尚無分析師",
  "auto.accuracy-12a3": "準確率",
  "auto.avg-brier-b28a": "平均 Brier 分數",
  "auto.top-token-cd22": "熱門代幣",
  "auto.analysts-5c55": "分析師",
  "auto.this-week-4e68": "本週",
  "auto.accuracy-trends-efd8": "準確率趨勢",
  "auto.prediction-types-c45b": "預測類型",
  "auto.token-performance-958c": "代幣表現",
  "auto.token-a114": "代幣",
  "auto.forecasts-1685": "預測",
  "auto.avg-confidence-0fb3": "平均信心度",
  "auto.checking-access-b7a3": "正在檢查權限...",
  "auto.content-type-863e": "內容類型",
  "auto.new-forecast-25b1": "新增預測",
  "auto.token-symbol-89a4": "代幣符號",
  "auto.prediction-type-343a": "預測類型",
  "auto.price-above-548f": "價格高於",
  "auto.price-below-36c2": "價格低於",
  "auto.change-6324": "漲跌幅 %",
  "auto.target-date-befd": "目標日期",
  "auto.premium-only-97e5": "僅限進階會員",
  "auto.title-768e": "標題",
  "auto.loading-b04b": "載入中...",
  "auto.event-not-found-0f7c": "找不到事件。",
  "auto.resolved-d999": "已結算",
  "auto.this-event-requires-ba95": "此事件需要",
  "auto.tier-access-15c9": "等級權限。",
  "auto.upgrade-subscription-a8c7": "升級訂閱",
  "auto.sign-in-to-submit-your-analysis-68fe": "登入以提交您的分析。",
  "auto.ai-analysis-resolution-93b9": "AI 分析與結算",
  "auto.outcome-d3f0": "結果",
  "auto.ai-pre-resolution-analysis-f91e": "AI 結算前分析",
  "auto.all-submissions-4ff2": "所有提交",
  "auto.forecast-not-found-28fe": "找不到預測",
  "auto.back-to-forecasts-bd16": "返回預測列表",
  "auto.open-cf9b": "進行中",
  "auto.correct-48e0": "正確",
  "auto.incorrect-7831": "錯誤",
  "auto.expired-a689": "已過期",
  "auto.forecast-detail-7798": "預測詳情",
  "auto.confidence-82fa": "信心度",
  "auto.price-at-creation-b02e": "建立時價格",
  "auto.target-price-9bf8": "目標價格",
  "auto.outcome-analysis-367b": "結果分析",
  "auto.unlock-with-pro-5bed": "使用 Pro 解鎖",
  "auto.my-submissions-15c8": "我的提交",
  "auto.by-accuracy-d903": "依準確率",
  "auto.by-brier-score-9e6f": "依 Brier 分數",
  "auto.by-forecasts-dafd": "依預測次數",
  "auto.by-followers-eea2": "依追蹤者數",
  "auto.top-performers-9693": "表現優異者",
  "auto.full-rankings-2acb": "完整排名",
  "auto.brier-e8ca": "Brier",
  "auto.get-started-bd2c": "立即開始",
  "auto.you-re-already-an-analyst-b48e": "您已經是分析師！",
  "auto.check-eligibility-0fae": "確認資格",
  "auto.intelligence-pro-or-elite-subscription-38e0": "Intelligence Pro 或 Elite 訂閱",
  "auto.verified-account-0051": "已驗證帳戶",
  "auto.your-email-is-verified-2ec3": "您的電子郵件已通過驗證",
  "auto.create-your-profile-a092": "建立個人檔案",
  "auto.back-b52b": "返回",
  "auto.add-details-f773": "新增詳細資訊",
  "auto.specialties-1b0c": "專業領域",
  "auto.review-confirm-eabb": "檢查並確認",
  "auto.profile-completion-e328": "個人檔案完成度",
  "auto.post-not-found-2a87": "找不到貼文",
  "auto.back-to-intelligence-ad5d": "返回 Intelligence",
  "auto.lessons-learned-e41d": "經驗總結",
  "auto.scenarios-2dd4": "情境分析",
  "auto.cancel-anytime-51e2": "隨時取消",
  "auto.30-day-refund-568a": "30 天退款保證",
  "auto.all-time-dbad": "歷史累計",
  "auto.month-082b": "本月",
  "auto.week-f82b": "本週",
  "auto.market-watch-85d4": "市場動態",
  "auto.currently-tracking-7267": "目前追蹤中",
  "auto.analysis-made-61f8": "已完成分析",
  "auto.ai-consensus-b979": "AI 共識",
  "auto.no-picks-yet-1019": "尚無精選預測",
  "auto.top-picks-f1cb": "熱門精選",
  "auto.all-markets-8582": "所有市場",
  "auto.recent-trades-2843": "近期交易",
  "auto.current-price-2f9f": "現價",
  "auto.volume-3b18": "交易量",
  "auto.ai-analysis-1569": "AI 分析：",
  "auto.status-bae7": "狀態",
  "auto.search-for-what-you-need-7d5b": "搜尋您需要的內容",
  "auto.podcast-not-found-c941": "找不到 Podcast",
  "auto.prediction-markets-c6ca": "預測市場",
  "auto.updating-3ab0": "更新中…",
  "auto.all-events-7f14": "所有事件",
  "auto.bookmarks-ca3c": "書籤",
  "auto.no-active-alerts-7617": "無進行中的提醒",
  "auto.event-not-found-231b": "找不到事件",
  "auto.total-vol-7a36": "總交易量",
  "auto.24h-vol-d841": "24h 交易量",
  "auto.liquidity-76a3": "流動性",
  "auto.featured-ae31": "精選",
  "auto.probability-chart-1fba": "機率圖表",
  "auto.outcomes-6848": "結果",
  "auto.trade-b081": "交易",
  "auto.outcome-probabilities-86db": "結果機率",
  "auto.no-markets-returned-b8e1": "未找到相關市場。",
  "auto.digest-47fd": "摘要",
  "auto.historical-bb2f": "歷史紀錄",
  "auto.account-85df": "帳戶",
  "auto.sort-volume-b0aa": "排序：交易量",
  "auto.sort-liquidity-d93a": "排序：流動性",
  "auto.sort-markets-5083": "排序：市場",
  "auto.sort-newest-682d": "排序：最新",
  "auto.your-watchlist-b916": "你的關注清單",
  "auto.sign-in-to-track-events-and-build-a-watc-50f5": "登入以追蹤事件並建立關注清單。",
  "auto.ai-market-copilot-3694": "AI Market Copilot",
  "auto.no-bookmarked-events-yet-0429": "目前尚無收藏的事件。",
  "auto.membership-53bc": "會員方案",
  "auto.month-f7fa": "/ 月",
  "auto.why-members-upgrade-74cc": "為什麼會員選擇升級",
  "auto.questions-9a1f": "常見問題",
  "auto.billing-cancellation-and-payouts-ce6e": "帳單、取消與付款。",
  "auto.couldn-t-load-press-releases-2907": "無法載入新聞稿",
  "auto.no-press-releases-yet-4851": "目前尚無新聞稿。",
  "auto.information-we-collect-ca19": "我們收集的資訊",
  "auto.account-details-804f": "帳戶詳細資料。",
  "auto.things-you-create-3254": "您建立的內容。",
  "auto.usage-data-e2b4": "使用資料。",
  "auto.messages-you-send-us-47d6": "您傳送給我們的訊息。",
  "auto.how-we-use-it-7f88": "我們如何使用資訊",
  "auto.cookies-and-analytics-9285": "Cookie 與分析",
  "auto.third-party-services-871d": "第三方服務",
  "auto.keeping-and-deleting-data-8d29": "資料保留與刪除",
  "auto.your-rights-e711": "您的權利",
  "auto.children-dcf7": "兒童隱私",
  "auto.changes-8aa5": "變更",
  "auto.profile-not-available-d9c0": "無法查看個人檔案",
  "auto.nothing-here-yet-e892": "此處尚無內容",
  "auto.your-account-4ab2": "您的帳戶",
  "auto.acceptable-use-009a": "使用規範",
  "auto.do-not-post-unlawful-hateful-misleading-0923": "請勿發布違法、仇恨、誤導性或辱罵性內容。",
  "auto.do-not-spam-scrape-in-bulk-or-attempt-to-977a": "請勿發送垃圾訊息、大量抓取資料，或試圖破壞或造成網站過載。",
  "auto.do-not-impersonate-other-people-or-misre-bd33": "請勿冒充他人或偽造您的所屬機構。",
  "auto.do-not-upload-content-you-do-not-have-th-0818": "請勿上傳您無權分享的內容。",
  "auto.content-you-post-5d23": "您發布的內容",
  "auto.our-content-01c1": "我們的內容",
  "auto.not-financial-advice-2a1f": "不構成投資建議",
  "auto.subscriptions-and-payments-e507": "訂閱與付款",
  "auto.third-party-material-and-links-5f0d": "第三方素材與連結",
  "auto.availability-and-liability-5aca": "服務可用性與責任限制",
  "auto.token-not-found-e894": "找不到代幣",
  "auto.this-topic-does-not-exist-or-is-not-publ-8eb4": "此主題不存在或尚未發布。",
  "auto.browse-all-topics-773a": "瀏覽所有主題",
  "auto.common-questions-f07a": "常見問題",
  "auto.related-topics-25bd": "相關主題",
  "auto.supported-0bf8": "支援",
  "auto.not-supported-in-this-browser-fb69": "此瀏覽器不支援",
  "auto.connect-an-outside-assistant-bb33": "連接外部助理",
  "auto.add-this-address-as-an-mcp-server-in-cha-7a2a": "將此地址新增為 ChatGPT、Claude、Cursor 或任何其他 MCP 用戶端中的 MCP 伺服器。",

  "auto.writer-bbad": "撰稿者",
  "auto.library-4d70": "資料庫",
  "auto.your-bookmarks-2e4c": "我的書籤",
  "auto.access-all-your-saved-articles-in-one-pl-f162": "集中存取您所有已儲存的文章。",
  "auto.today-in-crypto-d5e1": "今日加密動態",
  "auto.refresh-daily-data-db90": "重新整理每日數據",
  "auto.social-f431": "社群",
  "auto.your-feed-a02e": "個人動態",
  "auto.posts-comments-and-activity-from-people-fef8": "來自您關注對象的貼文、留言與動態。",
  "auto.search-posts-people-839f": "搜尋貼文與用戶…",
  "auto.room-code-a1a2": "房間代碼",
  "auto.multiplayer-901a": "多人連線",
  "auto.games-251b": "遊戲",
  "auto.play-multiplayer-games-with-the-byteline-57d0": "與 Byteline 社群一起暢玩多人遊戲。參與競爭、盡情享樂並賺取 XP。",
  "auto.no-games-available-4e8d": "目前沒有可用的遊戲",
  "auto.check-back-soon-for-new-games-4152": "請稍後再來查看新遊戲。",
  "auto.intelligence-pro-3e16": "Intelligence Pro",
  "auto.crypto-research-social-network-496e": "加密貨幣研究社群網路",
  "auto.follow-top-analysts-track-their-performa-85e2": "追蹤頂尖分析師、掌握其表現，並獲取優質研究報告。透過驗證過的預測準確率建立您的聲譽。",
  "auto.rankings-0d93": "排行榜",
  "auto.top-analysts-0d57": "頂尖分析師",
  "auto.ranked-by-forecast-accuracy-and-track-re-bd75": "依據預測準確率與歷史紀錄排名。",
  "auto.confidence-vs-accuracy-calibration-25d4": "信心度 vs 準確率（校準）",
  "auto.intelligence-8f7b": "情報分析",
  "auto.forecast-analytics-8780": "預測數據分析",
  "auto.comprehensive-analytics-on-prediction-ac-0924": "全面分析預測準確率、代幣表現與分析師模式。",
  "auto.target-value-b95e": "目標價值 ($)",
  "auto.investment-thesis-markdown-supported-d34a": "投資論點（支援 Markdown）",
  "auto.content-markdown-supported-2067": "內容（支援 Markdown）",
  "auto.create-content-2e8b": "建立內容",
  "auto.publish-a-forecast-thesis-playbook-or-ot-b927": "發布預測、論點、策略指南或其他分析。",
  "auto.enter-a-compelling-title-57a5": "輸入吸引人的標題…",
  "auto.weekly-events-986a": "每週事件",
  "auto.intelligence-events-f7ab": "情報事件",
  "auto.ai-curated-weekly-events-submit-your-ana-9dcf": "AI 篩選的每週事件。提交您的分析，預測正確的分析師可在結算時獲得平台獎勵池的獎勵。",
  "auto.intelligence-leaderboard-94f8": "情報排行榜",
  "auto.top-performing-analysts-ranked-by-predic-e50c": "表現最佳的分析師，依據預測準確率、Brier 分數及歷史紀錄排名。",
  "auto.display-name-f5f9": "顯示名稱 *",
  "auto.bio-b3eb": "個人簡介 *",
  "auto.twitter-x-optional-9850": "Twitter/X（選填）",
  "auto.telegram-optional-5a3a": "Telegram（選填）",
  "auto.become-an-analyst-c1cc": "成為分析師",
  "auto.join-intelligence-pro-and-share-your-cry-fa3a": "加入 Intelligence Pro，與社群分享您的加密貨幣洞見。",
  "auto.your-analyst-name-4ba7": "您的分析師名稱",
  "auto.tell-others-about-your-experience-and-ex-f227": "告訴大家您的經驗與專業知識（最少 100 字）",
  "auto.username-94b0": "@username",
  "auto.go-back-22b6": "返回",
  "auto.choose-your-plan-6389": "選擇您的方案",
  "auto.unlock-premium-crypto-research-create-fo-5b58": "解鎖進階加密貨幣研究、建立預測，並使用 AI Research Co-Pilot。",
  "auto.bytelline-e3c9": "Bytelline",
  "auto.leaderboard-e02b": "排行榜",
  "auto.one-ranking-reading-learning-forecasting-5ec8": "單一排行榜：結合閱讀、學習、預測與貢獻。",
  "auto.active-players-2a28": "活躍玩家",
  "auto.top-score-356a": "最高得分",
  "auto.learn-2f1a": "學習",
  "auto.web3-learning-2978": "Web3 學習",
  "auto.choose-a-path-to-start-your-journey-into-527b": "選擇學習路徑，開啟您的 Web3 與區塊鏈技術之旅。",
  "auto.no-learning-paths-yet-8f21": "尚無學習路徑",
  "auto.new-courses-are-on-the-way-2f85": "新課程即將上線。",
  "auto.plus-d7d1": "Plus",
  "auto.podcasts-byteline-6720": "Podcasts - Byteline",
  "auto.discover-and-listen-to-the-sharpest-show-3071": "探索並收聽關於科技、市場與創新的精闢節目。",
  "auto.audio-b22f": "音訊",
  "auto.podcasts-9bf7": "Podcasts",
  "auto.search-podcasts-f4ab": "搜尋 Podcasts...",
  "auto.search-podcasts-11ca": "搜尋 Podcasts",
  "auto.no-podcasts-found-39d2": "未找到相關 Podcasts",
  "auto.try-a-different-search-term-7f51": "請嘗試不同的搜尋關鍵字。",
  "auto.crypto-finance-markets-91ab": "加密貨幣與金融市場",
  "auto.track-crypto-and-finance-prediction-mark-56ea": "追蹤加密貨幣與金融預測市場。",
  "auto.sync-events-0d77": "同步事件",
  "auto.delete-alert-314c": "刪除提醒",
  "auto.search-events-b514": "搜尋事件...",
  "auto.prediction-markets-b485": "預測市場",
  "auto.market-intelligence-abf2": "市場情報",
  "auto.unified-view-of-global-event-markets-liv-8642": "跨 Kalshi 與 Polymarket 的全球事件市場、即時價格、交易量及 AI 輔助研究的整合檢視。",
  "auto.search-events-e-g-bitcoin-fed-election-eca7": "搜尋事件，例如比特幣、聯準會、選舉…",
  "auto.you-apos-re-on-premium-03b7": "您目前為 Premium 會員",
  "auto.upgrade-f683": "升級",
  "auto.premium-8d5e": "Premium",
  "auto.full-text-reading-ai-briefings-and-the-c-0e22": "每月只需 3 美元，即可享有全文閱讀、AI 簡報以及完整的 Byteline 文章檔案庫。",
  "auto.press-releases-byteline-3e54": "新聞稿 | Byteline",
  "auto.company-announcements-partnerships-and-f-e620": "提交給 Byteline 的企業公告、合作關係與融資新聞，按收到的原貌發布。",
  "auto.press-releases-01d7": "新聞稿",
  "auto.announcements-submitted-by-companies-and-ae2d": "由公司及其代表提交的公告。這些內容非 Byteline 編輯部的採訪報導。",
  "auto.search-1334": "搜尋",
  "auto.search-articles-e8de": "搜尋文章",
  "auto.search-articles-85ee": "搜尋文章...",
  "auto.social-byteline-f2fc": "社群 - Byteline",
  "auto.creators-we-follow-on-tiktok-and-instagr-9fb9": "我們在 TikTok 和 Instagram 上關注的創作者，涵蓋科技、市場與創新領域。",
  "auto.markets-52c3": "市場",
  "auto.live-crypto-prices-tech-equities-top-mov-a4b1": "即時加密貨幣價格、科技股、熱門漲跌股與您的追蹤清單，盡在一處。",
  "auto.search-name-or-symbol-b00d": "搜尋名稱或代號",
  "auto.topic-not-found-byteline-3c3a": "找不到主題 | Byteline",
  "auto.this-topic-does-not-exist-4f31": "此主題不存在。",
  "auto.topic-not-found-74e6": "找不到主題",
  "auto.topics-34ac": "主題",
  "auto.topics-byteline-d09e": "主題 | Byteline",
  "auto.guides-and-the-latest-coverage-across-ai-dec6": "涵蓋 AI、半導體、機器人、太空、生技、市場、加密貨幣等領域的指南與最新報導。",
  "auto.plain-english-guides-to-the-technologies-a483": "淺顯易懂的科技與市場指南，並提供各領域的最新報導。",
  "auto.ai-connect-webmcp-8b29": "AI Connect (WebMCP)",
  "auto.weekly-brief-fc26": "週報",
  "auto.no-brief-published-yet-d245": "尚未發布週報",
  "auto.the-first-weekly-brief-will-appear-here-6718": "第一份週報生成後將顯示於此。",
  "auto.something-went-wrong-6609": "發生錯誤",
  "auto.skip-backward-15-seconds-4da1": "倒轉 15 秒",
  "auto.skip-forward-15-seconds-087f": "快轉 15 秒",
  "auto.share-5a95": "分享",
  "auto.why-are-you-sharing-this-1535": "為什麼要分享這個？",
  "auto.sign-in-f2fd": "登入",
  "auto.sign-up-d678": "註冊",
  "auto.email-ce8a": "電子郵件",
  "auto.password-dc64": "密碼",
  "auto.full-name-6300": "姓名",
  "auto.you-example-com-4fca": "you@example.com",
  "auto.john-doe-4c2a": "John Doe",
  "auto.members-only-1fbc": "會員專屬",
  "auto.log-out-4394": "登出",
  "auto.share-your-thoughts-94d1": "分享您的想法...",
  "auto.volume-24h-828d": "成交量 (24小時)",
  "auto.summary-2906": "摘要",
  "auto.key-points-0c3f": "重點",
  "auto.positioning-a52f": "定位",
  "auto.risk-factors-1572": "風險因素",
  "auto.market-3184": "市場",
  "auto.price-drivers-ecd8": "價格驅動因素",
  "auto.competitive-landscape-4a0f": "競爭格局",
  "auto.adoption-985d": "採用情況",
  "auto.sentiment-f692": "市場情緒",
  "auto.technical-ad1e": "技術面",
  "auto.momentum-3732": "動能",
  "auto.development-activity-fe70": "開發活躍度",
  "auto.on-chain-metrics-f2bc": "鏈上指標",
  "auto.outlook-038e": "展望",
  "auto.create-price-alert-5471": "建立價格警示",
  "auto.skip-back-15-seconds-3196": "倒轉 15 秒",
  "auto.total-market-cap-9c2c": "總市值",
  "auto.24h-volume-c4d0": "24 小時成交量",
  "auto.btc-dominance-2a46": "BTC 市佔率",
  "auto.active-cryptos-ffc9": "活躍加密貨幣",
  "auto.nothing-to-see-here-yet-a18a": "尚無內容",
  "auto.when-you-follow-people-their-posts-will-4e18": "當您追蹤其他人時，他們的貼文會顯示在這裡。",
  "auto.the-feed-is-quiet-3196": "動態消息很平靜...",
  "auto.there-are-no-posts-to-show-right-now-che-50f0": "目前沒有可顯示的貼文，請稍後再來查看！",
  "auto.no-articles-shared-with-you-yet-b032": "尚無與您分享的文章",
  "auto.no-trending-topics-right-now-3638": "目前沒有熱門話題。",
  "auto.no-new-suggestions-right-now-ad66": "目前沒有新建議。",
  "auto.connecting-to-game-f48a": "正在連線至遊戲...",
  "auto.players-alive-a11c": "存活玩家：",
  "auto.time-421b": "時間：",
  "auto.wasd-or-joystick-move-0938": "WASD 或搖桿 - 移動",
  "auto.space-jump-2f3f": "Space - 跳躍",
  "auto.shift-dive-b431": "Shift - 俯衝",
  "auto.wawa-guys-2e36": "Wawa Guys",
  "auto.change-language-91d6": "切換語言",
  "auto.accuracy-d78f": "準確率",
  "auto.forecasts-46e2": "預測",
  "auto.followers-24c7": "追蹤者",
  "auto.win-rate-07a5": "勝率",
  "auto.verified-analyst-with-confirmed-identity-d570": "經身分驗證的認證分析師",
  "auto.verification-request-under-review-232b": "驗證申請審核中",
  "auto.markdown-supported-9516": "支援 Markdown",
  "auto.nothing-to-preview-a045": "無預覽內容",
  "auto.analyst-confidence-a744": "分析師信心度",
  "auto.loading-8524": "載入中...",
  "auto.price-3601": "價格",
  "auto.ask-about-this-token-a228": "詢問關於此代幣...",
  "auto.custom-amount-eb30": "自訂金額",
  "auto.resolved-f691": "已結算",
  "auto.correct-d0a3": "正確",
  "auto.partial-44ff": "部分正確",
  "auto.incorrect-a94d": "不正確",
  "auto.pending-2d13": "待定",
  "auto.no-submissions-yet-7db1": "尚無提交紀錄。",
  "auto.ai-judge-f6d9": "AI 裁判：",
  "auto.submissions-are-closed-awaiting-resoluti-0f50": "已截止提交。等待結算中。",
  "auto.your-analysis-bb53": "您的分析",
  "auto.one-submission-per-event-editable-until-65e5": "每個事件限提交一次。截止時間前皆可編輯。結算前對他人隱藏。",
  "auto.your-prediction-037c": "您的預測",
  "auto.reasoning-thesis-a7da": "推理 / 論點",
  "auto.what-do-you-think-will-happen-3a4b": "您認為會發生什麼事？",
  "auto.explain-your-reasoning-cite-sources-or-s-9553": "說明您的理由、引用來源或訊號...",
  "auto.scoring-983f": "計分",
  "auto.how-points-work-3888": "積分規則",
  "auto.scoring-rules-will-appear-here-82b7": "計分規則將顯示於此。",
  "auto.top-contributors-52e7": "頂尖貢獻者",
  "auto.full-rankings-466a": "完整排行榜",
  "auto.player-636d": "玩家",
  "auto.tier-9483": "階級",
  "auto.streak-f4bb": "連勝紀錄",
  "auto.score-5dd1": "得分",
  "auto.search-players-827d": "搜尋玩家…",
  "auto.score-composition-3866": "分數組成",
  "auto.your-standing-c680": "您的排名",
  "auto.sign-in-b6d4": "登入",
  "auto.overall-progress-e9d5": "整體進度",
  "auto.learning-leaderboard-e1fa": "學習排行榜",
  "auto.learning-rankings-ef2d": "學習排名",
  "auto.progress-46b5": "進度",
  "auto.out-of-lives-5b83": "生命值用盡！",
  "auto.until-next-life-66cd": "距離恢復生命",
  "auto.current-hearts-dcdf": "目前愛心",
  "auto.how-it-works-07cb": "運作方式：",
  "auto.your-completed-lessons-4475": "您已完成的課程",
  "auto.explanation-0bf1": "說明：",
  "auto.trending-3752": "熱門",
  "auto.top-gainers-0413": "漲幅榜",
  "auto.top-losers-d4cc": "跌幅榜",
  "auto.recently-added-e1a4": "最近新增",
  "auto.trend-structure-6f3d": "趨勢結構",
  "auto.levels-91ae": "關鍵位階",
  "auto.cryptos-843d": "加密貨幣：",
  "auto.market-cap-ff0a": "市值：",
  "auto.24h-vol-67f5": "24 小時成交量：",
  "auto.dominance-bc2e": "市佔率：",
  "auto.fear-greed-3bc6": "恐懼與貪婪：",
  "auto.name-49ee": "名稱",
  "auto.market-cap-81c9": "市值",
  "auto.circulating-supply-2a56": "流通供給量",
  "auto.last-7-days-4b29": "過去 7 天",
  "auto.reset-sort-4673": "重設排序",
  "auto.clear-date-range-2fb4": "清除日期範圍",
  "auto.remove-source-d074": "移除來源",
  "auto.search-articles-dd17": "搜尋文章",
  "auto.clear-search-9983": "清除搜尋",
  "auto.sort-articles-83b1": "文章排序",
  "auto.filters-f3f4": "篩選器",
  "auto.refresh-news-322e": "重新整理新聞",
  "auto.byteline-2fe0": "Byteline",
  "auto.exit-sphere-mode-dbd1": "退出球體模式",
  "auto.type-a-ticker-or-command-eq-nvda-mkt-new-6dda": "輸入代號或指令（例如 NVDA · mkt · news b · port）。按 / 聚焦。",
  "auto.loading-13d4": "載入中...",
  "auto.no-coverage-found-acc2": "未找到相關報導",
  "auto.loading-wire-3635": "正在載入快訊...",
  "auto.no-stories-15b2": "沒有新聞",
  "auto.last-98bd": "最新",
  "auto.download-episode-15a6": "下載單集",
  "auto.add-a-comment-9cf8": "新增留言...",
  "auto.stop-playback-d968": "停止播放",
  "auto.resolving-5e68": "結算中",
  "auto.sentiment-a0b4": "市場情緒：",
  "auto.key-factors-a050": "關鍵因素",
  "auto.total-vol-8020": "總成交量",
  "auto.24h-vol-0d59": "24小時成交量",
  "auto.liquidity-ced4": "流動性",
  "auto.set-price-alert-24fa": "設定價格警報",
  "auto.no-market-data-available-32ee": "無可用市場資料",
  "auto.ai-top-pick-201e": "AI 首選",
  "auto.ai-recommendation-6522": "AI 推薦",
  "auto.outcome-cf73": "結果",
  "auto.chance-332f": "% 機率",
  "auto.ai-pick-dcd1": "AI 選項",
  "auto.trade-5f39": "交易",
  "auto.select-outcome-2799": "選擇結果",
  "auto.alert-when-price-goes-7231": "當價格變動至",
  "auto.target-price-8689": "目標價格 (%)",
  "auto.bull-case-2541": "看漲情境",
  "auto.bear-case-c063": "看跌情境",
  "auto.risks-d179": "風險",
  "auto.no-live-arbitrage-opportunities-a3dc": "目前無即時套利機會。",
  "auto.regenerate-b232": "重新生成",
  "auto.no-digest-yet-click-regenerate-d188": "尚無摘要，請點擊重新生成。",
  "auto.top-arbs-3030": "熱門套利",
  "auto.whale-moves-3d39": "巨鯨動向",
  "auto.probability-shifts-4de8": "機率變化",
  "auto.kalshi-a929": "Kalshi",
  "auto.polymarket-0fa9": "Polymarket",
  "auto.top-of-book-8930": "最佳買賣價",
  "auto.orderbook-112f": "掛單簿",
  "auto.trades-18da": "交易紀錄",
  "auto.enter-a-market-id-and-click-fetch-149d": "輸入 market_id 並點擊「取得」。",
  "auto.market-id-af0e": "market_id",
  "auto.crypto-79ad": "加密貨幣",
  "auto.macro-4374": "總體經濟",
  "auto.waiting-for-messages-relay-session-lasts-f6a4": "正在等待訊息...（中繼階段約持續 50 秒，再次點擊即可重新連線）",
  "auto.tap-to-view-markets-7ece": "點擊查看市場。",
  "auto.ask-anything-4686": "輸入任何問題...",
  "auto.order-ticket-0daa": "委託單",
  "auto.limit-price-49cc": "限價 (¢)",
  "auto.shares-d272": "股數",
  "auto.confirm-your-order-2d1b": "確認訂單",
  "auto.cancel-ea47": "取消",
  "auto.select-an-outcome-9933": "選擇結果",
  "auto.trading-with-real-money-carries-real-ris-acf0": "使用真實資金交易具有實際風險。",
  "auto.eligibility-fb28": "資格：",
  "auto.how-your-credentials-are-handled-e38d": "您的憑證處理方式",
  "auto.disconnecting-a-venue-deletes-the-stored-3f3f": "中斷連結交易場所會立即刪除儲存的憑證。",
  "auto.connect-kalshi-d258": "連結 Kalshi",
  "auto.api-key-id-6452": "API 金鑰 ID",
  "auto.rsa-private-key-pem-b5cb": "RSA 私鑰 (PEM)",
  "auto.connect-polymarket-d376": "連結 Polymarket",
  "auto.polygon-private-key-afbf": "Polygon 私鑰",
  "auto.track-events-to-see-whale-trades-here-7591": "追蹤事件以在此查看巨鯨交易。",
  "auto.interpret-ad79": "解讀",
  "auto.click-interpret-to-classify-recent-whale-7e9f": "點擊「解讀」來分類最近的巨鯨交易。",
  "auto.go-premium-68e1": "升級 Premium",
  "auto.refer-amp-earn-88de": "推薦賺獎勵",
  "auto.sign-in-to-get-your-link-3a83": "登入以取得您的連結",
  "auto.your-referral-link-9360": "您的推薦連結",
  "auto.copy-referral-link-b233": "複製推薦連結",
  "auto.invited-aa34": "已邀請",
  "auto.subscribed-808c": "已訂閱",
  "auto.earned-0c19": "已賺取",
  "auto.0x-erc-20-or-t-trc-20-8ec0": "0x… (ERC-20) 或 T… (TRC-20)",
  "auto.search-tools-e30f": "搜尋工具...",
  "auto.custom-colour-ead5": "自訂顏色",
  "auto.custom-body-colour-a281": "自訂主體顏色",
  "auto.owned-avatar-2136": "已擁有的頭像",
  "auto.delete-avatar-66e0": "刪除頭像",
  "auto.enter-your-display-name-c3d9": "輸入您的顯示名稱",
  "auto.enter-your-username-dd62": "輸入您的使用者名稱",
  "auto.tell-us-about-yourself-490b": "介紹一下您自己...",
  "auto.streak-d832": "連續紀錄",
  "auto.what-s-on-your-mind-4a31": "在想些什麼？",
  "auto.edit-avatar-5dcd": "編輯頭像",
  "auto.edit-profile-dfd8": "編輯個人檔案",
  "auto.supports-jpg-png-max-10mb-6dac": "支援 JPG、PNG (最大 10MB)",
  "auto.uploaded-fe8d": "已上傳",
  "auto.generated-avatar-f8c8": "產生的頭像",
  "auto.previous-post-bc9d": "上一篇貼文",
  "auto.next-post-ebd8": "下一篇",
  "auto.play-the-next-video-automatically-7ca8": "自動播放下一支影片",
  "auto.play-this-video-a220": "播放此影片",
  "auto.resume-video-3494": "繼續播放影片",
  "auto.open-comments-b1b9": "開啟留言",
  "auto.about-this-post-3fd2": "關於本文",
  "auto.loading-videos-719c": "載入影片中...",
  "auto.add-a-comment-c3ed": "新增留言",
  "auto.delete-comment-547f": "刪除留言",
  "auto.share-this-issue-c878": "分享本期內容",
  "auto.fear-amp-greed-6b78": "恐懼 &amp; 貪婪",
  "auto.try-again-d876": "重試",
  "auto.this-story-couldn-t-be-loaded-in-full-he-2027": "無法在此處載入完整報導。您可以至原文出處閱讀。",
  "auto.press-release-5027": "新聞稿",
  "auto.back-0557": "返回",
  "auto.practice-completed-lessons-to-restore-yo-9210": "複習已完成的課程來恢復愛心！",
  "auto.practice-now-8cfb": "立即練習",
  "auto.back-to-podcast-b4fe": "返回 Podcast",
  "auto.related-news-1e3a": "相關新聞",
  "auto.back-to-games-e1a4": "返回遊戲",
  "auto.performance-over-time-00a3": "歷史表現",
  "auto.investment-thesis-d260": "投資論點",
  "auto.live-f35d": "即時",
  "auto.ai-powered-polymarket-prediction-trackin-5a1d": "AI 驅動的 Polymarket 預測追蹤",
  "auto.refresh-63a6": "重新整理",
  "auto.active-markets-6ab2": "活躍市場",
  "auto.ai-predictions-2a62": "AI 預測",
  "auto.top-pick-742c": "首選",
  "auto.no-consensus-picks-available-yet-run-ai-6b0c": "目前尚無共識選擇。請執行 AI 分析以產生預測。",
  "auto.advanced-search-cd4e": "進階搜尋",
  "auto.website-15bb": "官方網站",
  "auto.no-episodes-available-yet-794e": "目前尚無集數",
  "auto.back-to-markets-51bb": "返回市場",
  "auto.trade-on-polymarket-c80a": "在 Polymarket 進行交易",
  "auto.you-need-to-be-signed-in-to-view-your-pr-3611": "您需要登入才能檢視個人資料並分享想法。",
  "auto.the-token-you-re-looking-for-doesn-t-exi-2418": "您尋找的代幣不存在或已被移除。",
  "auto.whitepaper-bb56": "白皮書",
  "auto.github-d3b7": "GitHub",
  "auto.you-need-to-be-logged-in-to-bookmark-art-a40d": "您需要登入才能收藏文章並檢視已儲存的內容。",
  "auto.you-haven-t-bookmarked-any-articles-yet-0cef": "您尚未收藏任何文章。開始閱讀並收藏您喜愛的內容吧。",
  "auto.sign-in-to-see-your-activity-feed-includ-752b": "登入以查看您的個人動態，包括您的貼文、留言等內容。",
  "auto.create-a-new-room-or-join-an-existing-on-6fde": "建立新房間或加入現有房間",
  "auto.create-a-new-room-and-invite-your-friend-9557": "建立新房間並使用房間代碼邀請好友加入。",
  "auto.please-sign-in-to-create-a-room-0398": "請先登入以建立房間",
  "auto.enter-the-6-character-room-code-shared-b-b044": "輸入好友分享的 6 碼房間代碼。",
  "auto.join-a286": "加入",
  "auto.please-sign-in-to-join-a-room-cc52": "請先登入以加入房間",
  "auto.start-a-room-or-join-with-a-code-fde0": "建立房間或輸入代碼加入",
  "auto.share-the-code-with-friends-dea4": "與好友分享代碼",
  "auto.be-first-to-reach-the-finish-d35c": "率先抵達終點",
  "auto.play-de3c": "開始遊戲",
  "auto.get-started-e0c4": "立即開始",
  "auto.every-forecast-is-tracked-and-verified-s-df73": "每項預測皆經追蹤與驗證。呈現真實準確度評分，絕非空口無憑。",
  "auto.no-gambling-analysts-are-paid-for-resear-096d": "非關博弈。分析師報酬取決於研究品質，而非預測下注。",
  "auto.get-ai-powered-insights-from-news-and-po-c1f4": "在建立預測時，獲取新聞與 Podcast 的 AI 分析見解。",
  "auto.be-the-first-to-create-an-analyst-profil-39d9": "搶先建立分析師個人檔案！",
  "auto.be-the-first-to-join-the-intelligence-pr-e035": "搶先加入 Intelligence Pro 社群",
  "auto.you-already-have-an-analyst-profile-visi-2934": "您已建立分析師個人檔案。請造訪儀表板管理您的預測與文章。",
  "auto.view-profile-ccd9": "檢視個人檔案",
  "auto.verify-that-you-meet-the-requirements-to-c3d5": "確認您符合成為分析師的資格要求",
  "auto.subscribe-to-intelligence-pro-4161": "訂閱 Intelligence Pro",
  "auto.continue-a0bf": "繼續",
  "auto.set-up-your-analyst-identity-3e9c": "設定您的分析師身分",
  "auto.help-others-understand-your-expertise-819a": "讓他人了解您的專業領域",
  "auto.review-your-profile-before-submitting-0b1a": "提交前請檢查您的個人檔案",
  "auto.i-agree-to-the-terms-of-service-and-unde-ab09": "我同意服務條款，並瞭解系統將公開追蹤我的預測準確度",
  "auto.secure-payments-d4df": "安全付款",
  "auto.achievements-f5c7": "成就",
  "auto.sync-d8e8": "同步",
  "auto.ending-soon-19b1": "即將結束",
  "auto.newest-ac71": "最新",
  "auto.retry-6327": "重試",
  "auto.nothing-tracked-yet-use-the-star-icon-on-723c": "尚無追蹤項目，點擊任何事件上的星星圖示即可開始追蹤。",
  "auto.cross-venue-analysis-and-market-research-18fe": "隨選跨平台分析與市場研究。隨時提問即時市場資訊。",
  "auto.open-copilot-d576": "開啟 Copilot",
  "auto.update-your-payment-method-or-cancel-any-7f97": "隨時更新付款方式或取消訂閱。",
  "auto.secure-checkout-by-stripe-cancel-any-tim-0265": "由 Stripe 提供安全結帳。可隨時取消。",
  "auto.try-again-f915": "再試一次",
  "auto.previous-dd1f": "上一頁",
  "auto.next-10ac": "下一頁",
  "auto.loading-articles-cache-dc6d": "正在載入文章快取...",
  "auto.posts-from-the-creators-we-follow-will-a-c4e8": "您追蹤的創作者貼文將在收集後立即顯示於此。",
  "auto.read-the-guide-ef42": "閱讀指南",
  "auto.let-ai-assistants-work-directly-with-byt-7497": "讓 AI 助手直接處理 Byteline 報導、每日精華、週報及市場數據。",
  "auto.ai-article-analysis-d396": "AI 文章分析",
  "auto.related-prediction-markets-0177": "相關預測市場",
  "auto.ai-analysis-8fd8": "AI 分析",
  "auto.generating-ai-powered-analysis-56c6": "正在產生 AI 分析...",
  "auto.add-a-message-optional-1896": "新增訊息（選填）",
  "auto.share-with-f27e": "分享給",
  "auto.forgot-password-8458": "忘記密碼？",
  "auto.password-must-be-at-least-8-characters-l-db06": "密碼長度至少需 8 個字元",
  "auto.terms-of-service-3b6c": "服務條款",
  "auto.privacy-policy-fa2e": "隱私權政策",
  "auto.this-page-is-available-to-byteline-membe-6f22": "此頁面僅供 Byteline 會員存取。",
  "auto.sign-in-or-create-an-account-7b9d": "登入或建立帳號",
  "auto.profile-cce9": "個人檔案",
  "auto.bookmarks-7a69": "書籤",
  "auto.your-comment-on-this-story-514b": "您對這則報導的留言",
  "auto.get-ai-analysis-1f35": "取得 AI 分析",
  "auto.no-chart-data-available-8de1": "尚無圖表資料",
  "auto.daily-audio-recap-e3f1": "每日語音速報",
  "auto.your-browser-does-not-support-the-audio-cd02": "您的瀏覽器不支援此音訊元件。",
  "auto.daily-tech-recap-f2ce": "每日科技速報",
  "auto.today-s-tech-news-d448": "今日科技新聞",
  "auto.top-movers-today-34ee": "今日最大漲跌",
  "auto.auto-play-next-recap-291d": "自動播放下一則速報",
  "auto.unable-to-load-market-data-9492": "無法載入市場資料",
  "auto.when-people-share-articles-with-you-they-a0de": "當有人與您分享文章時，將會顯示於此",
  "auto.what-s-happening-ee6c": "發生的事",
  "auto.who-to-follow-ef20": "推薦追蹤",
  "auto.follow-3903": "追蹤",
  "auto.leave-game-063e": "離開遊戲",
  "auto.battle-royale-last-one-standing-wins-7811": "大逃殺 - 堅持到最後者勝！",
  "auto.invite-players-4736": "邀請玩家",
  "auto.start-game-1b07": "開始遊戲",
  "auto.waiting-for-host-to-start-2034": "等待主持人開始...",
  "auto.go-back-4f2f": "返回",
  "auto.no-articles-found-the-sync-process-is-ru-96a0": "找不到文章。背景同步程序正在運作中，以獲取最新新聞。",
  "auto.no-articles-match-your-current-filters-t-d861": "沒有符合您目前篩選條件的文章。請嘗試調整搜尋或篩選條件。",
  "auto.we-aggregate-reporting-from-leading-tech-a89f": "我們彙整頂尖科技、商業與金融媒體的報導，提供全面的新聞涵蓋。",
  "auto.market-trends-b918": "市場趨勢",
  "auto.view-all-tokens-d773": "檢視所有代幣",
  "auto.long-8394": "做多",
  "auto.short-30bb": "做空",
  "auto.no-performance-data-available-yet-a345": "尚無績效資料",
  "auto.most-popular-425e": "最熱門",
  "auto.trending-forecasts-5f36": "熱門預測",
  "auto.no-trending-forecasts-yet-5935": "尚無熱門預測",
  "auto.edit-7dce": "編輯",
  "auto.preview-31fd": "預覽",
  "auto.profile-completion-7b03": "個人資料完整度",
  "auto.research-co-pilot-2eeb": "研究 Copilot",
  "auto.show-your-appreciation-for-great-insight-be3b": "對優質觀點表達支持",
  "auto.navigation-8464": "導覽",
  "auto.home-8cf0": "首頁",
  "auto.news-dd1b": "新聞",
  "auto.tokens-f686": "代幣",
  "auto.resources-ddcf": "資源",
  "auto.about-8f7f": "關於",
  "auto.editorial-standards-bee2": "編採標準",
  "auto.contact-bbaf": "聯絡我們",
  "auto.privacy-c5f2": "隱私權",
  "auto.terms-6f1b": "條款",
  "auto.cookies-597b": "Cookie",
  "auto.no-rankings-yet-be-the-first-1539": "尚無排名，搶先成為第一名。",
  "auto.no-players-match-your-search-b9a7": "沒有符合搜尋條件的玩家。",
  "auto.sign-in-to-track-your-rank-streak-and-ti-982a": "登入以追蹤您的排名、連續紀錄與階級進度。",
  "auto.earn-your-first-xp-to-appear-on-the-lead-136e": "賺取你的第一個 XP 以登上排行榜。閱讀文章或完成課程即可開始。",
  "auto.jump-here-bf88": "跳至此處？",
  "auto.learning-achievements-2068": "學習成就",
  "auto.track-your-learning-progress-and-unlock-7404": "追蹤你的學習進度並解鎖成就",
  "auto.lessons-completed-6fe3": "已完成課程",
  "auto.learning-streak-bfb0": "連續學習紀錄",
  "auto.completion-2fea": "完成度",
  "auto.take-a-break-your-lives-will-regenerate-66b8": "休息一下！你的生命值會隨時間恢復，也可以透過練習來恢復。",
  "auto.practice-to-restore-hearts-4a1c": "透過練習恢復愛心",
  "auto.wait-for-lives-7577": "等待生命值恢復",
  "auto.complete-some-lessons-first-to-unlock-pr-5588": "先完成部分課程以解鎖練習模式！",
  "auto.review-and-earn-1-heart-291d": "複習並賺取 1 顆愛心",
  "auto.practice-8c00": "練習",
  "auto.check-060b": "檢查",
  "auto.show-more-146f": "顯示更多",
  "auto.load-more-articles-eb53": "載入更多文章",
  "auto.clear-all-81aa": "全部清除",
  "auto.sources-fb61": "來源",
  "auto.reset-526d": "重設",
  "auto.reset-all-09a5": "全部重設",
  "auto.loading-quotes-b905": "正在載入報價...",
  "auto.price-trace-8313": "價格走勢",
  "auto.related-headlines-5c77": "相關頭條",
  "auto.sell-8325": "賣出",
  "auto.reset-8626": "重設",
  "auto.no-open-positions-644a": "尚無持倉",
  "auto.no-comments-yet-be-the-first-to-comment-7ef4": "尚無留言。搶先成為第一個留言的人吧！",
  "auto.episode-description-d2d4": "單集簡介",
  "auto.view-episode-5504": "查看單集",
  "auto.stop-close-b6ae": "停止並關閉",
  "auto.ai-market-analysis-4df3": "AI 市場分析",
  "auto.generate-ai-analysis-0114": "產生 AI 分析",
  "auto.this-analysis-is-over-24-hours-old-consi-ec74": "此分析已超過 24 小時。建議重新產生以取得最新數據。",
  "auto.related-news-83c2": "相關新聞",
  "auto.from-byteline-8469": "來自 Byteline",
  "auto.no-related-news-found-f4e9": "未找到相關新聞",
  "auto.set-price-alert-cea7": "設定價格提醒",
  "auto.above-5b46": "高於",
  "auto.below-e59d": "低於",
  "auto.run-an-ai-analysis-combining-outcomes-oh-0fb8": "執行結合預測結果、OHLCV 與巨鯨動向的 AI 分析。",
  "auto.no-tradable-outcomes-on-this-event-yet-68d3": "此事件尚無可交易的預測結果。",
  "auto.this-sends-a-real-order-with-real-money-355f": "這將使用真實資金發送真實訂單，且無法從 Byteline 撤銷。",
  "auto.place-order-e796": "下單",
  "auto.sign-in-to-connect-a-trading-account-75f2": "登入以連結交易帳戶。",
  "auto.no-whale-trades-yet-track-an-event-from-7350": "尚無巨鯨交易，請從「市場」分頁追蹤事件。",
  "auto.premium-content-fd6f": "專屬付費內容",
  "auto.unlock-premium-cf87": "解鎖專屬內容",
  "auto.cancel-anytime-secure-checkout-via-strip-3655": "可隨時取消。透過 Stripe 安全結帳。",
  "auto.secure-checkout-via-stripe-cancel-anytim-702b": "透過 Stripe 安全結帳。可隨時取消。",
  "auto.you-will-be-redirected-to-stripe-to-comp-5491": "您將被重導向至 Stripe 以完成訂閱。",
  "auto.no-referrals-yet-share-your-link-to-get-af23": "尚無推薦記錄，分享您的連結開始邀請！",
  "auto.unlocked-298a": "已解鎖",
  "auto.no-activity-yet-start-by-creating-a-post-5295": "尚無動態。發佈文章或留言來開始吧！",
  "auto.customize-avatar-36dd": "自訂頭像",
  "auto.avatar-builder-b522": "頭像編輯器",
  "auto.done-f929": "完成",
  "auto.badge-unlocked-b911": "已解鎖徽章！",
  "auto.keep-up-the-amazing-work-and-unlock-more-0f90": "保持優異表現，解鎖更多徽章！",
  "auto.awesome-125a": "太棒了！",
  "auto.save-c9cc": "儲存",
  "auto.download-801a": "下載",
  "auto.celebrated-c46f": "已慶祝",
  "auto.check-back-later-for-today-s-tech-news-r-4179": "請稍後回來查看今日科技新聞速報",
  "auto.completed-07ca": "已完成",
  "auto.earn-10-xp-90c0": "獲得 10 XP",
  "auto.following-6f79": "追蹤中",
  "auto.you-re-not-following-anyone-yet-b2cb": "您尚未追蹤任何人",
  "auto.unfollow-3596": "取消追蹤",
  "auto.no-followers-yet-675a": "尚無追蹤者",
  "auto.week-1-9de8": "第 1 週",
  "auto.view-plans-0bfd": "查看方案",
  "auto.active-4d3d": "進行中",
  "auto.today-s-challenges-cbf1": "今日挑戰",
  "auto.no-challenges-assigned-yet-check-back-to-d7e8": "目前尚未分配任何挑戰。明天再來看看吧！",
  "auto.your-monthly-badges-a889": "您的每月徽章",
  "auto.edit-profile-1860": "編輯個人資料",
  "auto.browse-tools-0a7a": "瀏覽工具",
  "auto.add-tools-81fb": "新增工具",
  "auto.add-tokens-to-your-watchlist-to-track-th-eaca": "將代幣新增至追蹤清單，即可在此追蹤其表現。",
  "auto.add-tokens-e701": "新增代幣",
  "auto.add-token-550f": "新增代幣",
  "auto.edit-avatar-b497": "編輯頭像",
  "auto.crypto-enthusiast-4c52": "加密貨幣愛好者",
  "auto.change-photo-80de": "更換照片",
  "auto.browse-files-6b19": "瀏覽檔案",
  "auto.generating-avatar-27b5": "正在生成頭像...",
  "auto.generate-avatar-c695": "生成頭像",
  "auto.creating-your-pixel-art-avatar-this-may-380d": "正在建立您的像素風格頭像... 這可能需要 10 至 20 秒。",
  "auto.generate-again-3de1": "重新生成",
  "auto.added-f29d": "已新增",
  "auto.saving-575f": "儲存中...",
  "auto.your-post-262c": "您的貼文",
  "auto.posting-2d82": "發布中...",
  "auto.recent-searches-5c79": "最近搜尋",
  "auto.clear-dc30": "清除",
  "auto.suggestions-41ec": "建議",
  "auto.your-comment-on-this-video-0b0a": "您對此影片的留言",
  "auto.sign-in-to-comment-60a6": "登入以留言",
  "auto.further-reading-1ba5": "延伸閱讀",
  "auto.all-podcasts-d5fb": "所有 Podcast",
  "auto.weekly-performance-c408": "本週表現",
  "auto.market-data-was-unavailable-when-this-is-52ba": "產出本期內容時無法取得市場數據。",
  "auto.an-error-occurred-while-loading-this-pag-5668": "載入此頁面時發生錯誤，請重試。",
};
